import "./style.css";

const API = "/api";
const app = document.querySelector("#app");
const toastEl = document.querySelector("#toast");
const themes = [
  { id: "dawn", name: "晨曦", icon: "☀", tone: "暖白 · 珊瑚" },
  { id: "aurora", name: "极光", icon: "◒", tone: "薄荷 · 天蓝" },
  { id: "deep", name: "深空", icon: "✦", tone: "午夜 · 靛青" },
  { id: "ember", name: "余烬", icon: "◐", tone: "炭黑 · 琥珀" }
];
const themeSchedule = [
  { start: 0, end: 6, theme: "ember", label: "00:00–06:00" },
  { start: 6, end: 12, theme: "dawn", label: "06:00–12:00" },
  { start: 12, end: 18, theme: "aurora", label: "12:00–18:00" },
  { start: 18, end: 24, theme: "deep", label: "18:00–24:00" }
];
const storedThemeMode = localStorage.getItem("starmap-theme-mode") === "fixed" ? "fixed" : "auto";
const fallbackColors = ["#326BFF", "#7454D7", "#00A38B", "#D45C5C", "#C17700", "#377A8A", "#9E4770", "#477A45"];
const starMapImportExample = {
  version: 1,
  second_categories: [
    {
      name: "工作效率",
      third_categories: [
        {
          name: "AI 助手",
          sites: [
            {
              name: "豆包",
              url: "https://www.doubao.com/chat/",
              icon_url: "https://www.doubao.com/favicon.ico",
              description: "字节跳动旗下 AI 智能助手"
            }
          ]
        }
      ]
    }
  ]
};
const starMapImportExampleText = JSON.stringify(starMapImportExample, null, 2);
const state = {
  me: null,
  data: { categories: [], sites: [], engines: [] },
  defaultCategories: [],
  managedUsers: [],
  managedUserId: null,
  managedData: { user: null, categories: [], sites: [] },
  managedMode: "categories",
  accessControl: null,
  themeMode: storedThemeMode,
  theme: storedThemeMode === "fixed" && themes.some(theme => theme.id === localStorage.getItem("starmap-theme"))
    ? localStorage.getItem("starmap-theme")
    : automaticThemeForBeijing(),
  heroCompact: localStorage.getItem("starmap-hero") === "compact",
  view: "home",
  query: "",
  activeRoot: null,
  activeSecond: null,
  secondaryScrollLeft: {},
  managerSecondCategory: "all",
  managerCategory: "all",
  searchEngine: null,
  captcha: null
};
let automaticThemeTimer = null;
let thirdCategoryScrollHandler = null;

function escapeHtml(value = "") {
  return String(value).replace(/[&<>"']/g, c => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;"
  })[c]);
}

function api(path, options = {}) {
  return fetch(API + path, {
    credentials: "same-origin",
    ...options,
    headers: { "Content-Type": "application/json", ...(options.headers || {}) }
  }).then(async response => {
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      const detail = Array.isArray(data.detail)
        ? data.detail.map(item => item.msg || "格式不符合要求").join("；")
        : data.detail;
      throw new Error(detail || "请求失败");
    }
    return data;
  });
}

function toast(message, type = "") {
  toastEl.textContent = message;
  toastEl.className = `toast show ${type}`;
  clearTimeout(toast.timer);
  toast.timer = setTimeout(() => toastEl.className = "toast", 2600);
}

async function boot() {
  applyTheme(state.theme);
  startAutomaticThemeClock();
  try { state.me = await api("/me"); } catch { state.me = null; }
  restoreCategoryTabs();
  await loadData();
  render();
}

function beijingHour(date = new Date()) {
  try {
    const hour = Number(new Intl.DateTimeFormat("en-US", {
      timeZone: "Asia/Shanghai",
      hour: "2-digit",
      hourCycle: "h23"
    }).format(date));
    return hour % 24;
  } catch {
    return new Date(date.getTime() + 8 * 60 * 60 * 1000).getUTCHours();
  }
}

function automaticThemeForBeijing(date = new Date()) {
  const hour = beijingHour(date);
  return themeSchedule.find(period => hour >= period.start && hour < period.end)?.theme || "deep";
}

function startAutomaticThemeClock() {
  clearInterval(automaticThemeTimer);
  automaticThemeTimer = null;
  if (state.themeMode !== "auto") return;
  automaticThemeTimer = setInterval(syncAutomaticTheme, 60 * 1000);
}

function syncAutomaticTheme() {
  if (state.themeMode !== "auto") return;
  const nextTheme = automaticThemeForBeijing();
  if (nextTheme !== state.theme) applyTheme(nextTheme);
}

function setThemePreference(mode, theme = null) {
  state.themeMode = mode;
  localStorage.setItem("starmap-theme-mode", mode);
  applyTheme(mode === "auto" ? automaticThemeForBeijing() : theme);
  startAutomaticThemeClock();
}

document.addEventListener("visibilitychange", () => {
  if (!document.hidden) syncAutomaticTheme();
});

function categoryTabStorageKey() {
  return `starmap-category-tabs:${state.me?.id || "public"}`;
}

function restoreCategoryTabs() {
  try {
    const saved = JSON.parse(localStorage.getItem(categoryTabStorageKey()) || "{}");
    state.activeRoot = saved.root || null;
    state.activeSecond = saved.second || null;
  } catch {
    state.activeRoot = null;
    state.activeSecond = null;
  }
}

function persistCategoryTabs() {
  localStorage.setItem(categoryTabStorageKey(), JSON.stringify({
    root: state.activeRoot,
    second: state.activeSecond,
  }));
}

async function loadData() {
  if (state.me) {
    state.data = await api("/navigation");
    state.searchEngine = state.data.engines.find(e => e.is_default) || state.data.engines[0];
  } else {
    const publicData = await api("/public/navigation");
    state.data = { ...publicData, engines: [
      { id: "bing", name: "必应", icon: "B", url_template: "https://www.bing.com/search?q={q}", is_default: 1 },
      { id: "local", name: "站内", icon: "⌕", url_template: "local:{q}" }
    ] };
    state.searchEngine = state.data.engines[0];
  }
  normalizeCategoryTabs();
}

function normalizeCategoryTabs() {
  const { roots, byParent } = categoryTree();
  if (!roots.some(root => String(root.id) === String(state.activeRoot))) {
    state.activeRoot = roots[0]?.id || null;
  }
  const seconds = byParent[state.activeRoot] || [];
  if (!seconds.some(second => String(second.id) === String(state.activeSecond))) {
    state.activeSecond = seconds[0]?.id || null;
  }
  persistCategoryTabs();
}

function applyTheme(theme) {
  state.theme = theme;
  document.documentElement.dataset.theme = theme;
  localStorage.setItem("starmap-theme", theme);
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", {
    dawn: "#f8f2e9", aurora: "#edf8f6", deep: "#0a1126", ember: "#170f19"
  }[theme]);
  document.querySelectorAll(".brand-logo").forEach(img => {
    img.src = brandLogoSrc();
  });
  const currentTheme = themes.find(item => item.id === theme);
  const themeButton = document.querySelector("#theme-btn");
  if (currentTheme && themeButton) {
    themeButton.querySelector("span").textContent = currentTheme.icon;
    themeButton.querySelector("b").textContent = state.themeMode === "auto" ? `自动 · ${currentTheme.name}` : currentTheme.name;
    themeButton.title = state.themeMode === "auto" ? `跟随北京时间，当前为${currentTheme.name}` : `已固定为${currentTheme.name}`;
  }
}

function brandLogoSrc() {
  return ["deep", "ember"].includes(state.theme) ? "/logo-mark-dark.png" : "/favicon.ico";
}

function render() {
  teardownThirdCategoryNavigation();
  if (state.view === "home") renderHome();
  else renderWorkspace();
}

function topbar() {
  const currentTheme = themes.find(t => t.id === state.theme);
  const themeName = state.themeMode === "auto" ? `自动 · ${currentTheme.name}` : currentTheme.name;
  const { roots } = categoryTree();
  const homeTabs = roots.map(root =>
    `<button class="${state.view === "home" && String(state.activeRoot) === String(root.id) ? "active" : ""}" data-root="${root.id}">${escapeHtml(root.name)}</button>`
  ).join("");
  return `<header class="topbar">
    <button class="logo" data-view="home" aria-label="返回首页"><img class="brand-logo" src="${brandLogoSrc()}" alt="星图链"><span>星图链</span><small>STARMAP LINK</small></button>
    <nav class="top-nav">
      ${homeTabs}
      ${state.me ? `<button class="${state.view !== "home" ? "active" : ""}" data-view="sites">管理中心</button>` : ""}
    </nav>
    <div class="top-actions">
      <button class="share-site-btn" id="share-site-btn" aria-label="分享星图链" title="分享本站"><i class="share-glyph" aria-hidden="true"><i></i></i><b>分享本站</b></button>
      <button class="theme-toggle" id="theme-btn" aria-label="切换皮肤" title="${state.themeMode === "auto" ? `跟随北京时间，当前为${currentTheme.name}` : `已固定为${currentTheme.name}`}"><span>${currentTheme.icon}</span><b>${themeName}</b></button>
      ${state.me
        ? `<button class="user-btn" id="user-btn"><span>${escapeHtml(firstChar(state.me.username))}</span><b>${escapeHtml(state.me.username)}</b></button>`
        : `<button class="login-btn" id="login-btn">登录 / 注册</button>`}
    </div>
  </header>`;
}

function renderHome() {
  teardownThirdCategoryNavigation();
  const { roots, byParent } = categoryTree();
  const activeRoot = roots.find(root => String(root.id) === String(state.activeRoot));
  const activeCategoryIds = new Set(activeRoot ? allDescendantIds(activeRoot, byParent).map(String) : []);
  const activeRootCount = state.data.sites.filter(site => activeCategoryIds.has(String(site.category_id))).length;
  const curatedCount = state.data.sites.filter(s => s.is_curated).length;
  const personalCount = state.data.sites.filter(s => !s.is_curated).length;
  const thirdNav = thirdCategoryNav();
  app.innerHTML = `<div class="app-shell">
    ${topbar()}
    <main class="home-main">
      <section class="cosmos-deck ${state.heroCompact ? "compact" : ""}">
        <div class="orbit orbit-one"></div><div class="orbit orbit-two"></div>
        <div class="comet"></div>${starField()}
        <button class="hero-toggle" id="hero-toggle" type="button" aria-expanded="${state.heroCompact ? "false" : "true"}">${state.heroCompact ? "展开版头" : "收起版头"}</button>
        <div class="cosmos-copy">
          <p class="eyebrow">COLLECT THE WEB · LIGHT YOUR STARMAP</p>
          <h1>收藏全网，<em>点亮星图。</em></h1>
          <p>${state.me ? `欢迎回来，${escapeHtml(state.me.username)}。收藏、分类并快速抵达你常用的每一个网站。` : "无需登录即可浏览站长精选；登录后，用三级分类建立清晰、快捷的个人网址导航。"}</p>
        </div>
        <div class="cosmos-stats">
          <div><strong>${curatedCount}</strong><span>站长精选</span></div>
          ${state.me ? `<div><strong>${personalCount}</strong><span>私人收藏</span></div>` : `<div><strong>4</strong><span>主题皮肤</span></div>`}
        </div>
        <form class="quick-search" id="search-form">
          <button type="button" id="engine-btn"><span>${escapeHtml(state.searchEngine.icon)}</span><b>${escapeHtml(state.searchEngine.name)}</b></button>
          <input id="search-input" autocomplete="off" placeholder="快速筛选链接，或搜索互联网…" value="${escapeHtml(state.query)}">
          <button type="submit">搜索</button>
          <div class="engine-popover" id="engine-popover">${state.data.engines.map(e =>
            `<button type="button" data-engine="${e.id}" class="${String(e.id) === String(state.searchEngine.id) ? "selected" : ""}"><span>${escapeHtml(e.icon)}</span>${escapeHtml(e.name)}</button>`
          ).join("")}</div>
        </form>
      </section>

      <section class="link-toolbar">
        <div>
          <p class="eyebrow">CONSTELLATIONS</p>
          <h2>${escapeHtml(activeRoot?.name || "星图链")} <span>${activeRootCount} 个链接</span></h2>
        </div>
        ${state.me ? `<button class="primary-small" data-view="sites">＋ 添加与管理</button>` : `<button class="primary-small" id="join-btn">登录后收藏</button>`}
      </section>
      <section class="category-dock ${thirdNav ? "" : "without-thirds"}" aria-label="分类快捷导航">
        <div class="second-filter-wrap">
          <nav class="second-filter" aria-label="二级分类"><span class="second-filter-hint"><b>二级分类</b><small>点击快速切换</small></span>${secondaryTabs()}</nav>
          <span class="second-filter-controls" role="group" aria-label="滚动二级分类">
            <button type="button" data-scroll-second="-1" aria-label="查看前面的二级分类" title="向前查看更多二级分类">‹</button>
            <button type="button" data-scroll-second="1" aria-label="查看后面的二级分类" title="向后查看更多二级分类">›</button>
          </span>
          <span class="second-scroll-cue" aria-hidden="true"><i>←</i><b>向左滑动查看更多分类</b></span>
        </div>
        <div class="third-filter-wrap" id="third-filter-wrap">${thirdNav}</div>
      </section>
      <div id="site-sections">${renderSiteSections()}</div>
    </main>
    ${footer()}
  </div>`;
  bindGlobal();
  bindHome();
}

function starField() {
  return Array.from({ length: 26 }, (_, index) => {
    const x = (index * 37 + 11) % 97;
    const y = (index * 53 + 7) % 83;
    const delay = (index % 8) * .35;
    const size = index % 7 === 0 ? 4 : index % 3 === 0 ? 2 : 1;
    return `<i class="sky-star" style="left:${x}%;top:${y}%;width:${size}px;height:${size}px;animation-delay:${delay}s"></i>`;
  }).join("");
}

function categoryTree() {
  const byParent = {};
  state.data.categories.forEach(category => {
    (byParent[category.parent_id || 0] ||= []).push(category);
  });
  return { roots: byParent[0] || [], byParent };
}

function allDescendantIds(category, byParent) {
  const ids = [category.id];
  (byParent[category.id] || []).forEach(child => ids.push(...allDescendantIds(child, byParent)));
  return ids;
}

function renderSiteSections() {
  const { roots, byParent } = categoryTree();
  const root = roots.find(item => String(item.id) === String(state.activeRoot));
  const second = (byParent[root?.id] || []).find(item => String(item.id) === String(state.activeSecond));
  const thirds = second ? (byParent[second.id] || []) : [];
  const sections = thirds.map((third, thirdIndex) => {
    const sites = state.data.sites.filter(site => site.category_id === third.id && matchesQuery(site));
    if (!sites.length) return "";
    return `<section class="constellation-section" id="constellation-${third.id}" data-third-section="${third.id}">
      <header class="constellation-head">
        <div class="constellation-art art-${thirdIndex % 4}"><span>${escapeHtml(firstChar(third.name))}</span><i></i></div>
        <div><p class="eyebrow">${root?.is_curated ? "CURATED BY LEO" : "PRIVATE COLLECTION"}</p><h3>${escapeHtml(third.name)}</h3><small>${escapeHtml(second?.name || "")} · ${sites.length} 个链接</small></div>
      </header>
      <div class="site-grid">${sites.map(siteCard).join("")}</div>
    </section>`;
  }).join("");
  return sections || `<div class="empty-state"><span>✧</span><h3>${state.query ? "没有找到匹配的星星" : "这片星域还是空的"}</h3><p>${state.query ? "换个关键词再试试" : "登录后添加你的第一个网址。"}</p></div>`;
}

function activeThirdCategories() {
  const { roots, byParent } = categoryTree();
  const root = roots.find(item => String(item.id) === String(state.activeRoot));
  const second = (byParent[root?.id] || []).find(item => String(item.id) === String(state.activeSecond));
  return second ? (byParent[second.id] || []).filter(third =>
    state.data.sites.some(site => site.category_id === third.id && matchesQuery(site))
  ) : [];
}

function thirdCategoryNav() {
  const thirds = activeThirdCategories();
  if (!thirds.length) return "";
  return `<nav class="third-filter" aria-label="三级分类快捷跳转">
    <span class="third-filter-hint"><b>三级分类</b><small>${thirds.length} 个分区</small></span>
    ${thirds.map((third, index) => `<button class="${index === 0 ? "active" : ""}" type="button" data-third-target="${third.id}">${escapeHtml(third.name)}</button>`).join("")}
  </nav>`;
}

function secondaryTabs() {
  const { byParent } = categoryTree();
  const seconds = byParent[state.activeRoot] || [];
  return seconds.map(second => `<button class="${String(state.activeSecond) === String(second.id) ? "active" : ""}" data-second="${second.id}">${escapeHtml(second.name)}</button>`).join("");
}

function siteCard(site) {
  let hostname = "";
  try { hostname = new URL(site.url).hostname.replace(/^www\./, ""); } catch {}
  const description = site.description || hostname;
  const favorited = site.is_curated && isSiteFavorited(site);
  return `<article class="site-card-wrap">
    <a class="site-card" href="${escapeHtml(site.url)}" target="_blank" rel="noopener" data-site-id="${site.id}" data-curated="${site.is_curated ? "1" : "0"}" title="${escapeHtml(description)}">
      <span class="card-glow"></span>
      ${siteIcon(site)}
      <span class="site-info"><strong>${escapeHtml(site.name)}</strong><small>${escapeHtml(hostname)}</small><p>${escapeHtml(description)}</p></span>
      <span class="site-arrow">↗</span>
    </a>
    <button class="site-share-btn" type="button" data-share-site="${site.id}" aria-label="分享 ${escapeHtml(site.name)}" title="分享链接"><span>分享</span></button>
    ${state.me && site.is_curated ? `<button class="site-favorite-btn${favorited ? " is-favorited" : ""}" type="button" data-favorite-site="${site.id}" aria-label="${favorited ? "已收藏" : "收藏"} ${escapeHtml(site.name)}" title="${favorited ? "已在我的星图中" : "收藏到我的星图"}" ${favorited ? "disabled" : ""}><span>${favorited ? "已收藏" : "收藏"}</span></button>` : ""}
  </article>`;
}

function normalizedClientUrl(value) {
  try {
    const url = new URL(value);
    const hostname = url.hostname.toLowerCase();
    const host = hostname.includes(":") ? `[${hostname}]` : hostname;
    const defaultPort = (url.protocol === "http:" && url.port === "80") || (url.protocol === "https:" && url.port === "443");
    const port = url.port && !defaultPort ? `:${url.port}` : "";
    const path = url.pathname === "/" ? "" : url.pathname;
    return `${url.protocol}//${host}${port}${path}${url.search}`;
  } catch { return String(value || "").trim(); }
}

function isSiteFavorited(site) {
  const target = normalizedClientUrl(site.url);
  return state.data.sites.some(item => !item.is_curated && normalizedClientUrl(item.url) === target);
}

function siteIcon(site) {
  if (!site.icon_url) return fallbackIcon(site.name, site.id);
  return `<span class="site-icon-wrap"><img class="site-icon" src="${escapeHtml(site.icon_url)}" alt="" loading="lazy" referrerpolicy="no-referrer" data-name="${escapeHtml(site.name)}" data-id="${site.id}"></span>`;
}

function fallbackIcon(name, id = 0) {
  return `<span class="site-fallback" style="background:${fallbackColors[id % fallbackColors.length]}">${escapeHtml(firstChar(name))}</span>`;
}

function firstChar(value) {
  return Array.from(String(value || "·").trim())[0] || "·";
}

function matchesQuery(site) {
  if (!state.query) return true;
  const query = state.query.toLowerCase();
  return `${site.name} ${site.description || ""} ${site.url}`.toLowerCase().includes(query);
}

function bindGlobal() {
  app.querySelectorAll("[data-root]").forEach(button => {
    button.onclick = () => {
      rememberSecondaryScrollPosition();
      state.activeRoot = Number(button.dataset.root);
      state.activeSecond = null;
      state.view = "home";
      normalizeCategoryTabs();
      renderHome();
    };
  });
  app.querySelectorAll("[data-view]").forEach(button => {
    button.onclick = () => {
      if (!state.me && button.dataset.view !== "home") return showAuth("login");
      state.view = button.dataset.view;
      if (state.view === "sites" || state.view === "curated-sites") {
        state.managerSecondCategory = "all";
        state.managerCategory = "all";
      }
      render();
    };
  });
  app.querySelector("#share-site-btn").onclick = showWebsiteShare;
  app.querySelector("#theme-btn").onclick = showThemes;
  app.querySelector("#footer-terms")?.addEventListener("click", () => showTerms());
  if (state.me) app.querySelector("#user-btn").onclick = showAccount;
  else app.querySelector("#login-btn").onclick = () => showAuth("login");
  bindBrokenIcons();
}

function bindHome() {
  app.querySelectorAll("[data-second]").forEach(button => {
    button.onclick = () => {
      rememberSecondaryScrollPosition();
      state.activeSecond = Number(button.dataset.second);
      persistCategoryTabs();
      renderHome();
    };
  });
  app.querySelector("#hero-toggle").onclick = () => {
    state.heroCompact = !state.heroCompact;
    localStorage.setItem("starmap-hero", state.heroCompact ? "compact" : "expanded");
    renderHome();
  };
  app.querySelector("#join-btn")?.addEventListener("click", () => showAuth("login"));
  const popover = app.querySelector("#engine-popover");
  app.querySelector("#engine-btn").onclick = () => popover.classList.toggle("open");
  app.querySelectorAll("[data-engine]").forEach(button => {
    button.onclick = () => {
      state.searchEngine = state.data.engines.find(engine => String(engine.id) === button.dataset.engine);
      renderHome();
    };
  });
  app.querySelector("#search-input").oninput = event => {
    state.query = event.target.value.trim();
    refreshSiteSections();
  };
  app.querySelector("#search-form").onsubmit = event => {
    event.preventDefault();
    const query = app.querySelector("#search-input").value.trim();
    if (!query) return;
    if (state.searchEngine.url_template.startsWith("local:")) {
      state.query = query;
      refreshSiteSections();
    } else {
      window.open(state.searchEngine.url_template.replace("{q}", encodeURIComponent(query)), "_blank", "noopener");
    }
  };
  setupSecondaryScrollCue();
  setupThirdCategoryNavigation();
  bindSiteCards();
}

function refreshSiteSections() {
  app.querySelector("#site-sections").innerHTML = renderSiteSections();
  const thirdNav = thirdCategoryNav();
  app.querySelector("#third-filter-wrap").innerHTML = thirdNav;
  app.querySelector(".category-dock").classList.toggle("without-thirds", !thirdNav);
  setupThirdCategoryNavigation();
  bindSiteCards();
  bindBrokenIcons();
}

function teardownThirdCategoryNavigation() {
  if (!thirdCategoryScrollHandler) return;
  window.removeEventListener("scroll", thirdCategoryScrollHandler);
  window.removeEventListener("resize", thirdCategoryScrollHandler);
  thirdCategoryScrollHandler = null;
}

function setupThirdCategoryNavigation() {
  teardownThirdCategoryNavigation();
  const dock = app.querySelector(".category-dock");
  const filter = app.querySelector(".third-filter");
  const sections = [...app.querySelectorAll("[data-third-section]")];
  if (!dock || !filter || !sections.length) return;

  const activate = id => {
    filter.querySelectorAll("[data-third-target]").forEach(button => {
      button.classList.toggle("active", String(button.dataset.thirdTarget) === String(id));
    });
  };
  filter.querySelectorAll("[data-third-target]").forEach(button => {
    button.onclick = () => {
      const target = app.querySelector(`#constellation-${button.dataset.thirdTarget}`);
      if (!target) return;
      activate(button.dataset.thirdTarget);
      target.scrollIntoView({
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
        block: "start"
      });
      button.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    };
  });

  let ticking = false;
  thirdCategoryScrollHandler = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const topbarHeight = app.querySelector(".topbar")?.offsetHeight || 0;
      const threshold = topbarHeight + dock.offsetHeight + 20;
      let current = sections[0];
      sections.forEach(section => {
        if (section.getBoundingClientRect().top <= threshold) current = section;
      });
      activate(current.dataset.thirdSection);
      ticking = false;
    });
  };
  window.addEventListener("scroll", thirdCategoryScrollHandler, { passive: true });
  window.addEventListener("resize", thirdCategoryScrollHandler, { passive: true });
  thirdCategoryScrollHandler();
}

function setupSecondaryScrollCue() {
  const wrapper = app.querySelector(".second-filter-wrap");
  const filter = wrapper?.querySelector(".second-filter");
  if (!wrapper || !filter) return;
  const updateOverflow = () => {
    wrapper.classList.toggle("is-overflowing", filter.scrollWidth > filter.clientWidth + 6);
    const maxScroll = Math.max(0, filter.scrollWidth - filter.clientWidth);
    const previousButton = wrapper.querySelector('[data-scroll-second="-1"]');
    const nextButton = wrapper.querySelector('[data-scroll-second="1"]');
    if (previousButton) previousButton.disabled = filter.scrollLeft <= 6;
    if (nextButton) nextButton.disabled = filter.scrollLeft >= maxScroll - 6;
  };
  if (localStorage.getItem("starmap-secondary-swipe-seen") === "1") {
    wrapper.classList.add("is-seen");
  }
  const rootKey = String(state.activeRoot || "default");
  const savedLeft = Number(state.secondaryScrollLeft[rootKey] || 0);
  filter.addEventListener("scroll", () => {
    state.secondaryScrollLeft[rootKey] = filter.scrollLeft;
    updateOverflow();
    if (filter.scrollLeft > 8 && !wrapper.classList.contains("is-seen")) {
      wrapper.classList.add("is-seen");
      localStorage.setItem("starmap-secondary-swipe-seen", "1");
    }
  }, { passive: true });
  wrapper.querySelectorAll("[data-scroll-second]").forEach(button => {
    button.onclick = () => {
      const distance = Math.max(260, filter.clientWidth * .65) * Number(button.dataset.scrollSecond);
      filter.scrollLeft += distance;
    };
  });
  requestAnimationFrame(() => {
    filter.scrollLeft = Math.min(savedLeft, Math.max(0, filter.scrollWidth - filter.clientWidth));
    updateOverflow();
  });
}

function rememberSecondaryScrollPosition() {
  const filter = app.querySelector(".second-filter");
  if (!filter) return;
  state.secondaryScrollLeft[String(state.activeRoot || "default")] = filter.scrollLeft;
}

function bindSiteCards() {
  app.querySelectorAll(".site-card[data-site-id]").forEach(card => {
    card.onclick = () => {
      const path = card.dataset.curated === "1" && !state.me
        ? `/public/sites/${card.dataset.siteId}/click`
        : `/sites/${card.dataset.siteId}/click`;
      api(path, { method: "POST" }).catch(() => {});
    };
  });
  app.querySelectorAll("[data-share-site]").forEach(button => {
    button.onclick = event => {
      event.preventDefault();
      event.stopPropagation();
      const site = state.data.sites.find(item => item.id === Number(button.dataset.shareSite));
      if (site) showSiteShare(site);
    };
  });
  app.querySelectorAll("[data-favorite-site]").forEach(button => {
    button.onclick = event => {
      event.preventDefault();
      event.stopPropagation();
      if (button.disabled) return;
      const site = state.data.sites.find(item => item.id === Number(button.dataset.favoriteSite));
      if (site) showFavoriteSite(site);
    };
  });
}

function showFavoriteSite(site) {
  const categories = leafCategories(false);
  modal("收藏到我的星图", `<form id="favorite-site-form" class="form-stack">
    <div class="favorite-preview">${siteIcon(site)}<div><strong>${escapeHtml(site.name)}</strong><span>${escapeHtml(site.description || site.url)}</span><small>${escapeHtml(site.url)}</small></div></div>
    <label>选择第三级分类<select name="category_id" required><option value="">请选择收藏位置</option>${categories.map(category => `<option value="${category.id}">${escapeHtml(categoryPath(category.id))}</option>`).join("")}</select><small>收藏后可在“我的星图”中继续编辑、排序或删除。</small></label>
    ${categories.length ? "" : `<div class="notice"><strong>还没有可用的第三级分类</strong><span>请先到管理中心创建二级和三级分类，再收藏这个网址。</span></div>`}
    <button class="primary-btn" ${categories.length ? "" : "disabled"}>确认收藏 <span>→</span></button>
  </form>`);
  const form = document.querySelector("#favorite-site-form");
  form.onsubmit = async event => {
    event.preventDefault();
    event.submitter.disabled = true;
    try {
      const categoryId = Number(form.elements.category_id.value);
      await api(`/sites/favorite/${site.id}`, {
        method: "POST",
        body: JSON.stringify({ category_id: categoryId }),
      });
      await loadData();
      closeModal();
      renderHome();
      modal("收藏成功", `<div class="favorite-success"><span>✦</span><h3>${escapeHtml(site.name)} 已加入我的星图</h3><p>网址资料已完整保存，你可以继续浏览精选，或立即前往刚才选择的分类。</p><div class="share-actions"><button class="primary-btn" id="view-favorite">查看我的星图</button><button id="continue-curated">继续浏览精选</button></div></div>`);
      document.querySelector("#view-favorite").onclick = () => {
        const target = state.data.categories.find(category => category.id === categoryId);
        const personalRoot = state.data.categories.find(category => !category.is_curated && category.parent_id == null);
        state.activeRoot = personalRoot?.id || state.activeRoot;
        state.activeSecond = target?.parent_id || null;
        persistCategoryTabs();
        closeModal();
        renderHome();
      };
      document.querySelector("#continue-curated").onclick = closeModal;
    } catch (error) {
      toast(error.message, "error");
      event.submitter.disabled = false;
    }
  };
}

function showWebsiteShare() {
  showShareDialog({
    dialogTitle: "分享星图链",
    title: "星图链 · 收藏全网，点亮星图",
    url: "https://www.595951.xyz/",
    description: "用三级分类整理常用网站，浏览站长精选，建立清晰、快捷、属于你的个人网址导航。",
    iconHtml: `<span class="site-icon-wrap"><img class="site-icon" src="${brandLogoSrc()}" alt=""></span>`,
  });
}

function showSiteShare(site) {
  showShareDialog({
    dialogTitle: "分享这个链接",
    title: site.name,
    url: site.url,
    description: site.description || "来自星图链的网址分享",
    iconHtml: siteIcon(site),
  });
}

function showShareDialog({ dialogTitle, title, url, description, iconHtml }) {
  const shareText = `${title}\n${url}\n\n${description}`;
  modal(dialogTitle, `<div class="share-preview">
    <div class="share-brand"><img class="brand-logo" src="${brandLogoSrc()}" alt="星图链"><div><strong>星图链</strong><small>收藏全网，点亮星图</small></div></div>
    <div class="share-link-card">${iconHtml}<div><strong>${escapeHtml(title)}</strong><a href="${escapeHtml(url)}" target="_blank" rel="noopener">${escapeHtml(url)}</a></div></div>
    <textarea id="share-text" rows="7" readonly aria-label="可复制的分享内容">${escapeHtml(shareText)}</textarea>
    <div class="share-actions"><button class="primary-btn" id="copy-share"><span>复制分享内容</span><span>复制</span></button>${navigator.share ? `<button id="native-share">调用系统分享</button>` : ""}</div>
    <p class="share-tip">复制后可直接粘贴到微信、QQ、邮件或其他应用。</p>
  </div>`);
  document.querySelector("#copy-share").onclick = async () => {
    const textarea = document.querySelector("#share-text");
    try {
      await navigator.clipboard.writeText(shareText);
    } catch {
      textarea.focus();
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);
      document.execCommand("copy");
    }
    toast("分享内容已复制");
  };
  document.querySelector("#native-share")?.addEventListener("click", async () => {
    try {
      await navigator.share({ title, text: description, url });
    } catch (error) {
      if (error.name !== "AbortError") toast("系统分享暂不可用，请使用复制", "error");
    }
  });
}

function bindBrokenIcons() {
  app.querySelectorAll("img.site-icon").forEach(image => {
    image.onerror = () => {
      image.parentElement.outerHTML = fallbackIcon(image.dataset.name, Number(image.dataset.id));
    };
  });
}

function showThemes(pickerMode = state.themeMode) {
  const automaticTheme = automaticThemeForBeijing();
  const automaticThemeName = themes.find(theme => theme.id === automaticTheme).name;
  modal("选择星图皮肤", `
    <div class="theme-mode-switch" role="group" aria-label="皮肤更换方式">
      <button class="theme-mode-option ${pickerMode === "auto" ? "selected" : ""}" id="theme-mode-auto" type="button" aria-pressed="${pickerMode === "auto"}">
        <span>◷</span><strong>自动换肤</strong><small>跟随北京时间</small>
      </button>
      <button class="theme-mode-option ${pickerMode === "fixed" ? "selected" : ""}" id="theme-mode-fixed" type="button" aria-pressed="${pickerMode === "fixed"}">
        <span>◆</span><strong>固定皮肤</strong><small>始终使用所选主题</small>
      </button>
    </div>
    ${pickerMode === "auto" ? `
      <div class="theme-auto-summary"><strong>当前自动使用「${automaticThemeName}」</strong><small>页面保持打开或再次访问时，都会按北京时间自动校准。</small></div>
      <div class="theme-schedule" aria-label="自动换肤时间安排">${themeSchedule.map(period => {
        const theme = themes.find(item => item.id === period.theme);
        return `<span class="${automaticTheme === period.theme ? "current" : ""}"><b>${period.label}</b>${theme.name}</span>`;
      }).join("")}</div>
      <button class="primary-btn theme-confirm-auto" id="theme-confirm-auto" type="button">${state.themeMode === "auto" ? "保持自动换肤" : "启用自动换肤"}</button>
    ` : `
      <p class="theme-fixed-label">请选择要固定使用的皮肤，选择后将不再自动更换。</p>
      <div class="theme-grid">${themes.map(theme =>
      `<button class="theme-card theme-${theme.id} ${state.themeMode === "fixed" && state.theme === theme.id ? "selected" : ""}" data-theme="${theme.id}">
        <span>${theme.icon}</span><strong>${theme.name}</strong><small>${theme.tone}</small>
      </button>`).join("")}</div>
    `}`);
  document.querySelector("#theme-mode-auto").onclick = () => showThemes("auto");
  document.querySelector("#theme-mode-fixed").onclick = () => showThemes("fixed");
  document.querySelector("#theme-confirm-auto")?.addEventListener("click", () => {
    setThemePreference("auto");
    closeModal();
    render();
    toast(`已开启自动换肤，当前为${themes.find(theme => theme.id === state.theme).name}`);
  });
  document.querySelectorAll(".theme-card[data-theme]").forEach(button => {
    button.onclick = () => {
      setThemePreference("fixed", button.dataset.theme);
      closeModal();
      render();
      toast(`已固定使用${themes.find(t => t.id === state.theme).name}皮肤`);
    };
  });
}

function showAuth(mode = "login") {
  const register = mode === "register";
  modal(register ? "注册星图链" : "登录星图链", `
    <div class="auth-intro"><img class="brand-logo" src="${brandLogoSrc()}" alt="星图链"><div><strong>${register ? "创建你的私人星图" : "继续绘制你的星图"}</strong><p>公开精选无需登录，账号仅用于同步你的私人收藏。</p></div></div>
    <form id="auth-form" class="form-stack">
      <label>${register ? "用户名" : "账号"}<input name="${register ? "username" : "account"}" required autocomplete="username" placeholder="${register ? "2–32 个字符" : "用户名 / 手机号 / 邮箱"}"></label>
      ${register ? `<div class="form-row"><label>手机号 <small>选填</small><input name="phone" autocomplete="tel" placeholder="用于找回密码"></label><label>邮箱 <small>选填</small><input name="email" type="email" autocomplete="email" placeholder="用于找回密码"></label></div>` : ""}
      <label>密码<input name="password" required minlength="4" type="password" autocomplete="${register ? "new-password" : "current-password"}" placeholder="至少 4 位"></label>
      ${register ? `<div class="notice"><strong>建议填写手机号或邮箱</strong><span>用于管理员核验找回密码，注册后不可自行修改。</span></div>
        <label>验证码<div class="captcha-row"><span id="captcha-question">载入中…</span><input name="captcha_answer" required inputmode="numeric" placeholder="答案"><button type="button" class="text-btn" id="refresh-captcha">换一题</button></div></label>` : ""}
      <div class="terms-consent"><input id="terms-accepted" name="terms_accepted" type="checkbox" value="true" required><label for="terms-accepted">我已阅读并同意</label><button type="button" id="terms-link">《星图链服务条款》</button></div>
      <button class="primary-btn" type="submit">${register ? "创建账号" : "登录并同步"} <span>→</span></button>
    </form>
    <div class="auth-switch">${register ? `已有账号？<button data-auth="login">直接登录</button>` : `没有账号？<button data-auth="register">免费注册</button><button class="forgot" id="forgot">忘记密码</button>`}</div>`);
  document.querySelectorAll("[data-auth]").forEach(button => button.onclick = () => showAuth(button.dataset.auth));
  document.querySelector("#terms-link").onclick = () => showTerms(mode);
  if (register) {
    refreshCaptcha();
    document.querySelector("#refresh-captcha").onclick = refreshCaptcha;
  } else document.querySelector("#forgot").onclick = showForgot;
  document.querySelector("#auth-form").onsubmit = async event => {
    event.preventDefault();
    const values = Object.fromEntries(new FormData(event.target));
    if (register) values.captcha_token = state.captcha.token;
    event.submitter.disabled = true;
    try {
      await api(register ? "/auth/register" : "/auth/login", { method: "POST", body: JSON.stringify(values) });
      state.me = await api("/me");
      restoreCategoryTabs();
      await loadData();
      closeModal();
      state.view = "home";
      render();
      toast(`欢迎，${state.me.username}`);
    } catch (error) {
      toast(error.message, "error");
      if (register) refreshCaptcha();
      event.submitter.disabled = false;
    }
  };
}

function showTerms(returnMode = null) {
  modal("星图链服务条款", `<article class="terms-document">
    <div class="terms-summary"><strong>重要提示</strong><p>请重点阅读加粗内容，尤其是用户链接责任、平台处置权、第三方服务、责任限制和争议解决条款。</p></div>
    <p class="terms-date">版本及生效日期：2026 年 7 月 28 日</p>

    <h3>一、条款适用与接受</h3>
    <p>本条款是您与星图链网站运营者之间关于访问、注册和使用星图链服务的协议。点击同意、注册、登录或继续使用服务，表示您已阅读并同意本条款。若您不同意，请勿注册、登录或使用需要账号的功能。</p>

    <h3>二、服务内容与性质</h3>
    <p>星图链提供公开网址精选、个人网址收藏、三级分类管理、搜索及链接分享等工具。除明确标注为星图链自有内容外，用户收藏的网址、网页内容和第三方服务均由相应用户或第三方提供。链接的收录、展示或排序不代表星图链对第三方内容作出推荐、担保、授权或背书。</p>

    <h3>三、账号与使用资格</h3>
    <p>您应具备与使用行为相适应的民事行为能力，并提供真实、合法、有效的注册信息。未成年人应在监护人指导和同意下使用。您应妥善保管账号凭证，并对账号下的操作承担责任；发现账号异常时应及时联系网站运营者。</p>

    <h3>四、用户提交链接的责任</h3>
    <p><strong>您是通过账号收藏、添加、编辑、命名、描述或分享链接的直接责任人，应确保相关链接及其标题、描述、图标、使用目的和指向内容具有合法来源或必要授权，不侵犯任何第三方的知识产权、名誉权、隐私权、个人信息权益、商业秘密及其他合法权益。</strong></p>
    <p>无论链接设为私人收藏还是由管理员配置为公开精选，均不得用于制作、复制、发布、传播、引流或协助访问违法和不良信息，包括但不限于：危害国家安全和公共利益；恐怖、暴力、淫秽色情、赌博、毒品、违禁品；诈骗、传销、非法集资或其他违法金融活动；侵害未成年人权益；谣言、仇恨、歧视、侮辱诽谤；侵犯知识产权、隐私或个人信息；恶意软件、钓鱼、窃取数据、绕过监管或安全措施；以及法律法规禁止的其他内容。</p>
    <p><strong>您不得利用星图链为违法活动提供导航、推广、技术支持、交易撮合或其他帮助。因您提交或使用链接引发的投诉、索赔、行政调查、处罚或其他损失，由您依法承担相应责任。</strong></p>

    <h3>五、平台管理与处置</h3>
    <p>星图链有权依法依约采用人工或技术方式进行巡查，但这不构成对全部用户链接的事先审查义务或对其合法性的保证。发现或合理怀疑链接违法、侵权、存在安全风险或违反本条款时，平台可不经事先通知采取警示、限制访问、取消公开展示、删除或断开链接、暂停功能、冻结或关闭账号、保存记录、向主管机关报告等必要措施。紧急情况下可先行处置。</p>

    <h3>六、第三方网站与交易风险</h3>
    <p>第三方网站独立运营，其内容、可用性、收费、隐私政策和安全措施不受星图链控制。访问第三方网站前，您应自行核验域名、资质和风险。您与第三方发生的登录、授权、下载、购买、支付、咨询或其他交易由您和第三方自行负责。星图链不索取第三方网站密码，也不会为第三方交易提供担保。</p>

    <h3>七、侵权通知与投诉举报</h3>
    <p>权利人或公众发现链接涉嫌侵权、违法或存在安全风险，可发送邮件至 <a href="mailto:leo@595951.xyz">leo@595951.xyz</a>。通知应尽量包含：通知人真实身份及联系方式、具体链接和定位信息、权利证明或违法事实的初步证据、要求采取的措施，以及对通知真实性负责的声明。</p>
    <p>平台收到合格通知后，将结合初步证据和服务类型依法采取删除、屏蔽、断开链接等必要措施，并可将通知转送相关用户。用户可依法提交不存在侵权的声明和初步证据。错误或恶意通知造成损害的，通知人应依法承担责任。</p>

    <h3>八、知识产权</h3>
    <p>星图链的界面、品牌标识、程序和原创内容受法律保护。您保留对合法提交内容依法享有的权利，并授予星图链仅为提供、维护、展示、分享和治理服务所必要的、非独占、可撤销的使用许可。私人收藏不会因本条款被授权用于公开宣传。</p>

    <h3>九、个人信息与数据</h3>
    <p>为提供账号与同步服务，平台可能处理用户名、密码哈希、选填的手机号或邮箱、会话信息、IP、设备与浏览器信息、访问记录以及您保存的链接和分类。平台将以实现账号、安全、同步、运营和法定义务所必要的范围与期限处理，不出售个人信息。依法应向主管机关提供、为保护用户或平台合法权益所必需，或取得您另行同意的情形除外。您可通过上述邮箱申请查询、更正或删除相关个人信息和账号。</p>

    <h3>十、服务变更与可用性</h3>
    <p>平台可因维护、升级、安全、合规或不可抗力调整、暂停或终止部分服务，并在合理范围内尽力减少影响。请自行保留重要链接备份。平台不保证服务永久不中断，也不保证第三方链接持续有效。</p>

    <h3>十一、责任限制</h3>
    <p><strong>在法律允许的范围内，星图链仅对因自身过错直接造成且依法应由平台承担的损失负责，不对第三方网站行为、用户违法使用、链接失效或篡改，以及间接损失、预期利益损失或数据未备份导致的损失承担超出法律规定的责任。</strong>本条款不排除或限制因平台故意、重大过失、人身损害或法律明确规定不得排除的责任。</p>

    <h3>十二、违约责任</h3>
    <p>您违反本条款或法律法规，平台可采取本条款约定的处置措施。因您的行为使平台或第三方遭受索赔、处罚或合理支出的，您应在法律允许范围内承担相应赔偿责任。平台未立即行使权利不构成放弃。</p>

    <h3>十三、法律适用与争议解决</h3>
    <p><strong>本条款适用中华人民共和国大陆地区法律。争议应先友好协商；协商不成的，可依法向有管辖权的人民法院提起诉讼。</strong>本条款部分内容无效不影响其他条款效力。</p>

    <h3>十四、条款更新与联系</h3>
    <p>平台可因功能或法律变化更新条款，并通过页面提示等合理方式告知。涉及用户重大权益的变化将在合理范围内突出提示。联系方式：<a href="mailto:leo@595951.xyz">leo@595951.xyz</a>。</p>
    <div class="terms-actions"><button class="primary-btn" id="terms-back">${returnMode ? "返回并继续" : "我已阅读"}</button></div>
  </article>`, "terms-modal");
  document.querySelector("#terms-back").onclick = returnMode ? () => showAuth(returnMode) : closeModal;
}

async function refreshCaptcha() {
  state.captcha = await api("/auth/captcha");
  const node = document.querySelector("#captcha-question");
  if (node) node.textContent = state.captcha.question;
}

function showForgot() {
  modal("忘记密码", `<div class="forgot-info"><div class="mail-orbit">✉</div>
    <p>请联系网站管理员：<a href="mailto:leo@595951.xyz">leo@595951.xyz</a></p>
    <ol><li><strong>邮箱验证（最快）</strong><br>使用注册邮箱发信并注明用户名。</li><li><strong>手机验证</strong><br>发信注明账号和注册手机号，管理员电话核验后重置。</li></ol>
    <p class="muted">核验后密码重置为 <code>1234</code>，请登录后立即修改。</p></div>`);
}

function showAccount() {
  modal("账号设置", `<div class="profile-head"><span>${escapeHtml(firstChar(state.me.username))}</span><div><h3>${escapeHtml(state.me.username)}</h3><p>${escapeHtml(state.me.email || state.me.phone || "未填写找回方式")}</p></div></div>
    <div class="settings-list"><button id="change-password">修改密码 <span>→</span></button><button data-account-view="sites">进入管理中心 <span>→</span></button>${state.me.is_admin ? `<button data-account-view="curated-sites">管理站长精选 <span>→</span></button>` : ""}<button id="logout" class="danger">退出登录 <span>→</span></button></div>`);
  document.querySelector("#change-password").onclick = showPassword;
  document.querySelectorAll("[data-account-view]").forEach(button => button.onclick = () => {
    state.view = button.dataset.accountView; closeModal(); render();
  });
  document.querySelector("#logout").onclick = async () => {
    await api("/auth/logout", { method: "POST" });
    state.me = null; state.view = "home"; restoreCategoryTabs(); closeModal();
    await loadData(); render(); toast("已退出，仍可浏览站长精选");
  };
}

function showPassword() {
  modal("修改密码", `<form id="password-form" class="form-stack"><label>当前密码<input type="password" name="old_password" required></label><label>新密码<input type="password" name="new_password" minlength="4" required></label><button class="primary-btn">保存新密码</button></form>`);
  document.querySelector("#password-form").onsubmit = async event => {
    event.preventDefault();
    try {
      await api("/me/password", { method: "PUT", body: JSON.stringify(Object.fromEntries(new FormData(event.target))) });
      closeModal(); toast("密码已更新");
    } catch (error) { toast(error.message, "error"); }
  };
}

function workspaceNav() {
  const links = [
    ["sites", "◈", "我的网址"],
    ["categories", "⌘", "我的分类"],
    ["engines", "⌕", "搜索引擎"]
  ];
  if (state.me.is_admin) links.push(
    ["curated-sites", "✦", "精选网址"],
    ["curated-categories", "⎈", "精选分类"],
    ["default-categories", "◇", "新账号默认分类"],
    ["user-star", "♙", "用户星图"],
    ["groups", "⊕", "用户组与权限"],
    ["users", "◎", "用户与终端"]
  );
  return `<aside class="workspace-nav"><p>管理中心</p>${links.map(([id, icon, label]) =>
    `<button class="${state.view === id ? "active" : ""}" data-view="${id}"><span>${icon}</span>${label}</button>`
  ).join("")}<button data-view="home" class="back-home"><span>←</span>返回星图</button></aside>`;
}

function renderWorkspace() {
  if (!state.me) { state.view = "home"; return renderHome(); }
  app.innerHTML = `<div class="app-shell workspace-shell">${topbar()}<main class="workspace">${workspaceNav()}<section class="workspace-content">${workspaceContent()}</section></main>${footer()}</div>`;
  bindGlobal();
  bindWorkspace();
}

function workspaceContent() {
  if (state.view === "sites") return sitesManager(false);
  if (state.view === "categories") return categoriesManager(false);
  if (state.view === "engines") return enginesManager();
  if (state.view === "curated-sites") return sitesManager(true);
  if (state.view === "curated-categories") return categoriesManager(true);
  if (state.view === "default-categories") return `<div class="page-head"><div><p class="eyebrow">NEW ACCOUNT TEMPLATE</p><h1>新账号默认分类</h1><p>新用户注册时会复制这里配置的“我的星图”三级结构。</p></div><button class="primary-small" id="add-default-category">＋ 添加分类</button></div><div id="default-category-tree"><div class="loading">正在读取默认分类…</div></div>`;
  if (state.view === "user-star") return `<div class="page-head"><div><p class="eyebrow">MANAGED USER STARMAP</p><h1>用户专属星图</h1><p>选择用户后，代为维护其私人分类和网址。</p></div></div><div id="managed-user-workspace"><div class="loading">正在读取用户星图…</div></div>`;
  if (state.view === "groups") return `<div class="page-head"><div><p class="eyebrow">ACCESS CONTROL</p><h1>用户组与权限</h1><p>按用户组增加功能权限，或开放额外的站长精选二级分类。</p></div><button class="primary-small" id="add-user-group">＋ 新建用户组</button></div><div id="access-control-workspace"><div class="loading">正在读取权限配置…</div></div>`;
  if (state.view === "users") return `<div class="page-head"><div><p class="eyebrow">ADMINISTRATION</p><h1>用户与登录终端</h1><p>查看全站用户、收藏和终端活跃情况。</p></div></div><div id="admin-overview"><div class="loading">正在汇总数据…</div></div>`;
  return "";
}

function sitesManager(curated) {
  const sites = state.data.sites.filter(site => Boolean(site.is_curated) === curated);
  const categories = state.data.categories.filter(category => Boolean(category.is_curated) === curated);
  const { byParent } = categoryTreeFor(categories);
  const roots = byParent[0] || [];
  const seconds = roots.flatMap(root => byParent[root.id] || []);
  const selectedSecond = seconds.find(category => String(category.id) === String(state.managerSecondCategory));
  if (!selectedSecond) state.managerSecondCategory = "all";
  const allThirds = seconds.flatMap(second => byParent[second.id] || []);
  const visibleThirds = selectedSecond ? (byParent[selectedSecond.id] || []) : allThirds;
  if (state.managerCategory !== "all" && !visibleThirds.some(category => String(category.id) === String(state.managerCategory))) {
    state.managerCategory = "all";
  }
  const visibleThirdIds = new Set(visibleThirds.map(category => category.id));
  const filtered = state.managerCategory !== "all"
    ? sites.filter(site => String(site.category_id) === String(state.managerCategory))
    : selectedSecond
      ? sites.filter(site => visibleThirdIds.has(site.category_id))
      : sites;
  const groupedThirds = state.managerCategory === "all"
    ? visibleThirds
    : visibleThirds.filter(category => String(category.id) === String(state.managerCategory));
  const grouped = groupedThirds.map(category => ({
    category, sites: filtered.filter(site => site.category_id === category.id)
  })).filter(group => !curated || group.sites.length);
  const canImport = curated ? Boolean(state.me?.is_admin) : Boolean(state.me?.features?.bookmark_import);
  const canExport = curated ? Boolean(state.me?.is_admin) : Boolean(state.me?.features?.bookmark_export);
  return `<div class="page-head"><div><p class="eyebrow">${curated ? "PUBLIC CURATION" : "PRIVATE COLLECTION"}</p><h1>${curated ? "站长精选网址" : "我的网址"}</h1><p>${curated ? "这里的链接无需登录即可被所有访客看到。" : "按分类维护私人链接，不再把所有内容塞进一个弹窗。"}</p></div><div class="page-actions">${canImport ? `<button class="secondary-btn" id="import-bookmarks">${curated ? "导入精选" : "导入星图"}</button>` : ""}${canExport ? `<button class="secondary-btn" id="export-bookmarks">${curated ? "导出精选" : "导出星图"}</button>` : ""}<button class="primary-small" id="add-site">＋ 添加网址</button></div></div>
    <div class="manager-filter"><div class="manager-filter-fields">
      <label>按二级分类查看<select id="manager-second-category"><option value="all">全部二级分类</option>${seconds.map(category => `<option value="${category.id}" ${String(state.managerSecondCategory) === String(category.id) ? "selected" : ""}>${escapeHtml(category.name)}</option>`).join("")}</select></label>
      <label>按三级分类精确查看<select id="manager-category"><option value="all">${selectedSecond ? `全部“${escapeHtml(selectedSecond.name)}”网址` : "全部三级分类"}</option>${visibleThirds.map(category => `<option value="${category.id}" ${String(state.managerCategory) === String(category.id) ? "selected" : ""}>${escapeHtml(selectedSecond ? category.name : categoryPath(category.id))}</option>`).join("")}</select></label>
    </div><span>${filtered.length} 个网址</span></div>
    <div class="manager-groups">${grouped.map(group => `<section class="manager-group"><header><div><h2>${escapeHtml(group.category.name)}</h2><p>${escapeHtml(categoryPath(group.category.id))}</p></div><div class="manager-group-actions"><span>${group.sites.length} 个网址</span>${curated ? "" : `<button type="button" data-add-site-category="${group.category.id}">＋ 添加网址</button>`}</div></header><div class="manage-list">${group.sites.length ? group.sites.map((site, index) => manageSiteRow(site, index, group.sites.length, curated)).join("") : `<div class="manager-group-empty">这个分类还没有网址，可直接点击上方“添加网址”。</div>`}</div></section>`).join("") || `<div class="empty-state"><span>✧</span><h3>没有符合筛选条件的网址</h3><p>可以切换分类筛选后继续查看。</p></div>`}</div>`;
}

function manageSiteRow(site, index, total, curated) {
  return `<article class="manage-row" data-manage-site="${site.id}">${siteIcon(site)}<div class="manage-copy"><strong>${escapeHtml(site.name)}</strong><p>${escapeHtml(site.description || site.url)}</p><small>${escapeHtml(site.url)} · 点击 ${site.click_count} 次</small></div><div class="row-actions"><button type="button" data-move="up" ${index === 0 ? "disabled" : ""} aria-label="上移 ${escapeHtml(site.name)}" title="上移">↑</button><button type="button" data-move="down" ${index === total - 1 ? "disabled" : ""} aria-label="下移 ${escapeHtml(site.name)}" title="下移">↓</button><button type="button" data-edit-site="${site.id}" data-curated="${curated ? "1" : "0"} class="edit-action">✎ 编辑</button><button type="button" data-delete-site="${site.id}" data-curated="${curated ? "1" : "0"} class="danger">删除</button></div></article>`;
}

function categoriesManager(curated) {
  const categories = state.data.categories.filter(category => Boolean(category.is_curated) === curated);
  const { byParent } = categoryTreeFor(categories);
  const roots = byParent[0] || [];
  return `<div class="page-head"><div><p class="eyebrow">${curated ? "PUBLIC TAXONOMY" : "PRIVATE TAXONOMY"}</p><h1>${curated ? "站长精选分类" : "我的分类"}</h1><p>三级结构单独维护；删除分类会同时删除其下级分类与网址。</p></div><button class="primary-small" id="add-category">＋ 添加分类</button></div>
    <div class="category-tree">${roots.map((root, index) => categoryBranch(root, byParent, curated, 1, index, roots.length)).join("") || `<div class="empty-state">暂无分类</div>`}</div>`;
}

function categoryTreeFor(categories) {
  const byParent = {};
  categories.forEach(category => (byParent[category.parent_id || 0] ||= []).push(category));
  return { byParent };
}

function categoryBranch(category, byParent, curated, level = 1, index = 0, siblingCount = 1, template = false) {
  const children = byParent[category.id] || [];
  return `<section class="category-branch level-${level}"><header><div class="level-badge">L${level}</div><div><strong>${escapeHtml(category.name)}</strong><small>${template ? escapeHtml(templateCategoryPath(category.id)) : escapeHtml(categoryPath(category.id))}</small></div><div class="row-actions">
    <button data-move-category="${category.id}" data-direction="up" data-curated="${curated ? "1" : "0"} data-template="${template ? "1" : "0"} ${index === 0 ? "disabled" : ""} title="上移">↑</button>
    <button data-move-category="${category.id}" data-direction="down" data-curated="${curated ? "1" : "0"} data-template="${template ? "1" : "0"} ${index === siblingCount - 1 ? "disabled" : ""} title="下移">↓</button>
    <button data-edit-category="${category.id}" data-curated="${curated ? "1" : "0"} data-template="${template ? "1" : "0"}>编辑</button>
    ${level === 1 ? "" : `<button data-delete-category="${category.id}" data-curated="${curated ? "1" : "0"} data-template="${template ? "1" : "0"} class="danger">删除</button>`}
  </div></header>${children.map((child, childIndex) => categoryBranch(child, byParent, curated, level + 1, childIndex, children.length, template)).join("")}</section>`;
}

function enginesManager() {
  return `<div class="page-head"><div><p class="eyebrow">SEARCH SETTINGS</p><h1>搜索引擎</h1><p>搜索只是辅助入口，默认引擎仍可自由设置。</p></div></div>
    <div class="engine-layout"><div class="manage-list">${state.data.engines.map(engine => `<article class="manage-row"><div class="engine-avatar">${escapeHtml(engine.icon)}</div><div class="manage-copy"><strong>${escapeHtml(engine.name)}</strong><small>${escapeHtml(engine.url_template)}</small></div><div class="row-actions">${engine.is_default ? `<span class="default-chip">默认</span>` : `<button data-default-engine="${engine.id}">设为默认</button><button data-delete-engine="${engine.id}" class="danger">删除</button>`}</div></article>`).join("")}</div>
    <form id="engine-form" class="form-stack side-form"><h2>添加搜索引擎</h2><div class="form-row"><label>名称<input name="name" required></label><label>图标字符<input name="icon" value="⌕" maxlength="2"></label></div><label>关键字<input name="keyword" required placeholder="例如 baidu"></label><label>搜索地址<input name="url_template" required placeholder="https://example.com/search?q={q}"><small>用 {q} 代表搜索词</small></label><button class="primary-btn">添加</button></form></div>`;
}

function bindWorkspace() {
  app.querySelector("#add-site")?.addEventListener("click", () => showSiteEditor(null, state.view === "curated-sites"));
  app.querySelectorAll("[data-add-site-category]").forEach(button => {
    button.onclick = () => showSiteEditor(null, false, null, Number(button.dataset.addSiteCategory));
  });
  app.querySelector("#import-bookmarks")?.addEventListener("click", () => showBookmarkImport(state.view === "curated-sites"));
  app.querySelector("#export-bookmarks")?.addEventListener("click", () => showBookmarkExport(state.view === "curated-sites"));
  app.querySelector("#add-user-group")?.addEventListener("click", () => {
    if (state.accessControl) showUserGroupEditor();
  });
  app.querySelector("#add-category")?.addEventListener("click", () => showCategoryEditor(null, state.view === "curated-categories"));
  app.querySelector("#add-default-category")?.addEventListener("click", () => showCategoryEditor(null, false, true));
  app.querySelector("#manager-second-category")?.addEventListener("change", event => {
    state.managerSecondCategory = event.target.value;
    state.managerCategory = "all";
    renderWorkspace();
  });
  app.querySelector("#manager-category")?.addEventListener("change", event => {
    state.managerCategory = event.target.value; renderWorkspace();
  });
  app.querySelectorAll("[data-edit-site]").forEach(button => button.onclick = event => {
    event.preventDefault();
    event.stopPropagation();
    const site = state.data.sites.find(item => item.id === Number(button.dataset.editSite));
    showSiteEditor(site, button.dataset.curated === "1");
  });
  app.querySelectorAll("[data-delete-site]").forEach(button => button.onclick = event => {
    event.preventDefault();
    event.stopPropagation();
    deleteSite(Number(button.dataset.deleteSite), button.dataset.curated === "1");
  });
  app.querySelectorAll("[data-move]").forEach(button => button.onclick = event => {
    event.preventDefault();
    event.stopPropagation();
    moveSite(Number(button.closest("[data-manage-site]").dataset.manageSite), button.dataset.move, state.view === "curated-sites");
  });
  bindCategoryActions();
  app.querySelectorAll("[data-default-engine]").forEach(button => button.onclick = async () => {
    await api(`/engines/${button.dataset.defaultEngine}/default`, { method: "PUT" }); await loadData(); renderWorkspace();
  });
  app.querySelectorAll("[data-delete-engine]").forEach(button => button.onclick = async () => {
    await api(`/engines/${button.dataset.deleteEngine}`, { method: "DELETE" }); await loadData(); renderWorkspace();
  });
  const engineForm = app.querySelector("#engine-form");
  if (engineForm) engineForm.onsubmit = async event => {
    event.preventDefault();
    try {
      await api("/engines", { method: "POST", body: JSON.stringify(Object.fromEntries(new FormData(event.target))) });
      await loadData(); renderWorkspace(); toast("搜索引擎已添加");
    } catch (error) { toast(error.message, "error"); }
  };
  if (state.view === "users") loadAdminOverview();
  if (state.view === "default-categories") loadDefaultCategories();
  if (state.view === "user-star") loadManagedUserWorkspace();
  if (state.view === "groups") loadAccessControl();
  bindBrokenIcons();
}

function readTextFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () => reject(new Error("无法读取书签文件"));
    reader.readAsText(file, "UTF-8");
  });
}

function starMapAiPrompt(organize = false) {
  const modeRules = organize
    ? `采用“智能整理”模式：根据网站实际用途重新归类。二级分类应稳定、宽泛，建议 4—12 个；三级分类应具体、易扫读。合并重复或过细分类，把无法判断的项目放入“待整理 / 暂未分类”。`
    : `采用“保持原分类”模式：尽量保留原来的分类名称和顺序，不主动改变分类含义。原始层级超过三级时，把更深层路径合理合并到三级分类名称中；原始层级不足时，只补充最少的“其他 / 待整理”分类。`;
  return `你是“星图链”网址数据转换助手。请把我随后提供的书签、网址列表或杂乱分类，转换为可直接导入星图链的 JSON。

${modeRules}

必须严格遵守：
1. 星图链一级分类“我的星图”是固定的，不要输出一级分类；输出只能包含二级分类、三级分类和网址。
2. 每个网址必须且只能放在一个三级分类中，不能把网址直接放在二级分类下。
3. 原始数据超过三级时必须压缩为二级 + 三级；不得丢失有效网址。原始数据很杂乱时，按上述模式处理。
4. 只保留完整的 http:// 或 https:// 网址；按规范化网址去重，保留信息更完整的一条。绝对不要编造网址。
5. 网站名称缺失时可从域名推断简洁名称；description、icon_url 不确定时用空字符串，不要编造宣传描述或图标地址。
6. 分类名称不超过 40 个字符，网站名称不超过 100 个字符，描述不超过 500 个字符。单次最多 500 个网址。
7. 必须只输出一个合法 JSON 对象，不要 Markdown 代码围栏，不要解释、备注、统计或 JSON 之外的文字。
8. 字段名和层级必须与下方示例完全一致：

${starMapImportExampleText}

下面是需要转换的原始内容：
[请把你的网址列表、浏览器书签内容或现有分类粘贴在这里]`;
}

async function copyPlainText(content, successMessage) {
  try {
    await navigator.clipboard.writeText(content);
  } catch {
    const textarea = document.createElement("textarea");
    textarea.value = content;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    textarea.remove();
  }
  toast(successMessage);
}

function downloadTextFile(content, filename, type) {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

function parseStarMapJson(source) {
  let clean = String(source || "").trim();
  clean = clean.replace(/^```(?:json)?\s*/i, "").replace(/\s*```$/, "").trim();
  if (!clean.startsWith("{")) {
    const first = clean.indexOf("{");
    const last = clean.lastIndexOf("}");
    if (first >= 0 && last > first) clean = clean.slice(first, last + 1);
  }
  return JSON.parse(clean);
}

function showBookmarkImport(curated = false) {
  if (curated) return showLegacyBookmarkImport(true);
  modal("导入完整“我的星图”", `<form id="star-map-import-form" class="form-stack">
    <div class="notice"><strong>一次导入二级分类、三级分类和网址</strong><span>推荐使用星图链 JSON；已有同名分类会复用，重复网址会跳过，不会覆盖或删除现有内容。单次最多 200 个分类、500 个网址。</span></div>
    <section class="import-guide">
      <div><p class="eyebrow">FORMAT</p><h3>星图链 JSON 格式</h3><p>一级“我的星图”由系统固定创建。文件从 <code>second_categories</code> 开始，每个二级分类内必须有 <code>third_categories</code>，网址只能放在三级分类的 <code>sites</code> 中。</p></div>
      <div class="import-guide-actions"><button type="button" class="secondary-btn" id="download-import-example">下载示例 JSON</button><button type="button" class="secondary-btn" id="legacy-bookmark-import">旧版 HTML 导入单个分类</button></div>
      <details><summary>查看完整格式示例</summary><pre>${escapeHtml(starMapImportExampleText)}</pre></details>
    </section>
    <section class="ai-import-helper">
      <div><p class="eyebrow">AI CONVERTER</p><h3>让 AI 帮你生成合规格式</h3><p>先选择是否需要 AI 重新整理分类，再把复制的提示词和原始网址列表发给任意 AI。AI 返回 JSON 后直接粘贴到下方即可。</p></div>
      <div class="prompt-choice-grid"><button type="button" id="copy-preserve-prompt"><strong>保持原分类</strong><small>尽量保留现有名称和顺序，只压缩超过三级的层级。</small></button><button type="button" id="copy-organize-prompt"><strong>帮我智能整理</strong><small>按网站用途重新分组，合并杂乱、重复或过细分类。</small></button></div>
    </section>
    <label>粘贴星图链 JSON<textarea name="star_map_json" rows="10" spellcheck="false" placeholder='粘贴以 { "version": 1, "second_categories": [...] } 开头的 JSON'></textarea></label>
    <label>或者选择 JSON 文件<input name="star_map_file" type="file" accept=".json,application/json"><small>粘贴内容和文件二选一；若同时提供，优先读取文件。最大 5 MB。</small></label>
    <button class="primary-btn">检查并导入完整星图 <span>→</span></button>
  </form>`, "wide-modal");
  document.querySelector("#download-import-example").onclick = () => downloadTextFile(
    starMapImportExampleText,
    "星图链导入格式示例.json",
    "application/json;charset=utf-8",
  );
  document.querySelector("#legacy-bookmark-import").onclick = () => showLegacyBookmarkImport(false);
  document.querySelector("#copy-preserve-prompt").onclick = () => copyPlainText(
    starMapAiPrompt(false), "“保持原分类”AI 提示词已复制"
  );
  document.querySelector("#copy-organize-prompt").onclick = () => copyPlainText(
    starMapAiPrompt(true), "“智能整理”AI 提示词已复制"
  );
  document.querySelector("#star-map-import-form").onsubmit = async event => {
    event.preventDefault();
    const form = event.currentTarget;
    const file = form.elements.star_map_file.files[0];
    if (file?.size > 5 * 1024 * 1024) return toast("JSON 文件不能超过 5 MB", "error");
    event.submitter.disabled = true;
    try {
      const source = file ? await readTextFile(file) : form.elements.star_map_json.value;
      if (!source.trim()) throw new Error("请粘贴 JSON 或选择 JSON 文件");
      const payload = parseStarMapJson(source);
      const result = await api("/sites/import-star-map", {
        method: "POST",
        body: JSON.stringify(payload),
      });
      await loadData();
      closeModal();
      render();
      toast(`新建 ${result.categories_created} 个分类，导入 ${result.imported} 个网址；复用分类 ${result.categories_reused} 个，跳过重复 ${result.duplicates} 个，无效 ${result.invalid} 个`);
    } catch (error) {
      toast(error instanceof SyntaxError ? "JSON 格式不正确，请使用示例或 AI 提示词重新生成" : error.message, "error");
      event.submitter.disabled = false;
    }
  };
}

function showLegacyBookmarkImport(curated = false) {
  const categories = leafCategories(curated);
  modal(curated ? "导入站长精选网址" : "导入浏览器书签到单个分类", `<form id="bookmark-import-form" class="form-stack">
    <div class="notice"><strong>支持标准浏览器书签 HTML</strong><span>${curated ? "导入内容将公开显示在站长精选中。" : "可从 Chrome、Edge 或 Firefox 的书签管理器导出；"}单次最多导入 500 条，重复网址会自动跳过。</span></div>
    <label>导入到第三级分类<select name="category_id" required><option value="">请选择目标分类</option>${categories.map(category => `<option value="${category.id}">${escapeHtml(categoryPath(category.id))}</option>`).join("")}</select></label>
    <label>书签文件<input name="bookmark_file" type="file" accept=".html,.htm,text/html" required><small>文件仅在浏览器中解析网址，再发送到星图链；最大 5 MB。</small></label>
    ${categories.length ? "" : `<div class="notice">请先创建${curated ? "站长精选" : "“我的星图”"}第三级分类。</div>`}
    <button class="primary-btn" ${categories.length ? "" : "disabled"}>开始导入 <span>→</span></button>
  </form>`);
  document.querySelector("#bookmark-import-form").onsubmit = async event => {
    event.preventDefault();
    const form = event.currentTarget;
    const file = form.elements.bookmark_file.files[0];
    if (!file) return toast("请选择书签 HTML 文件", "error");
    if (file.size > 5 * 1024 * 1024) return toast("书签文件不能超过 5 MB", "error");
    event.submitter.disabled = true;
    try {
      const source = await readTextFile(file);
      const documentNode = new DOMParser().parseFromString(source, "text/html");
      const anchors = Array.from(documentNode.querySelectorAll("a[href]"));
      if (!anchors.length) throw new Error("文件中没有找到可导入的书签");
      const items = anchors.slice(0, 500).map(anchor => ({
        name: (anchor.textContent || "").trim(),
        url: (anchor.getAttribute("href") || "").trim(),
        icon_url: anchor.getAttribute("icon") || anchor.getAttribute("icon_uri") || null,
      }));
      const result = await api(curated ? "/admin/curated/sites/import" : "/sites/import", {
        method: "POST",
        body: JSON.stringify({
          category_id: Number(form.elements.category_id.value),
          items,
        }),
      });
      await loadData();
      closeModal();
      render();
      toast(`导入 ${result.imported} 条，跳过重复 ${result.duplicates} 条，无效 ${result.invalid} 条`);
    } catch (error) {
      toast(error.message, "error");
      event.submitter.disabled = false;
    }
  };
}

function showBookmarkExport(curated = false) {
  if (curated) return exportBookmarks(true);
  modal("导出“我的星图”", `<div class="export-choice-grid">
    <button id="export-star-map-json"><span>JSON</span><strong>星图链完整备份</strong><small>保留二级、三级分类、网址、图标和描述，可再次完整导入。推荐。</small></button>
    <button id="export-browser-html"><span>HTML</span><strong>浏览器书签文件</strong><small>可导入 Chrome、Edge、Firefox 等浏览器，并保留文件夹层级。</small></button>
  </div>`);
  document.querySelector("#export-star-map-json").onclick = () => {
    exportStarMapJson();
    closeModal();
  };
  document.querySelector("#export-browser-html").onclick = () => {
    exportBookmarks(false);
    closeModal();
  };
}

function exportStarMapJson() {
  const categories = state.data.categories.filter(category => !category.is_curated);
  const sites = state.data.sites.filter(site => !site.is_curated);
  const { byParent } = categoryTreeFor(categories);
  const root = (byParent[0] || [])[0];
  const payload = {
    version: 1,
    second_categories: (byParent[root?.id] || []).map(second => ({
      name: second.name,
      third_categories: (byParent[second.id] || []).map(third => ({
        name: third.name,
        sites: sites.filter(site => site.category_id === third.id).map(site => ({
          name: site.name,
          url: site.url,
          icon_url: site.icon_url || "",
          description: site.description || "",
        })),
      })),
    })),
  };
  downloadTextFile(
    JSON.stringify(payload, null, 2),
    `星图链完整备份-${new Date().toISOString().slice(0, 10)}.json`,
    "application/json;charset=utf-8",
  );
  toast(`已导出 ${sites.length} 个网址及完整分类结构`);
}

function exportBookmarks(curated = false) {
  const categories = state.data.categories.filter(category => Boolean(category.is_curated) === curated);
  const sites = state.data.sites.filter(site => Boolean(site.is_curated) === curated);
  const { byParent } = categoryTreeFor(categories);
  const renderFolder = (category, depth = 1) => {
    const padding = "    ".repeat(depth);
    const children = (byParent[category.id] || []).map(child => renderFolder(child, depth + 1));
    const links = sites.filter(site => site.category_id === category.id).map(site => {
      const icon = site.icon_url ? ` ICON="${escapeHtml(site.icon_url)}"` : "";
      const description = site.description ? `\n${padding}    <DD>${escapeHtml(site.description)}` : "";
      return `${padding}    <DT><A HREF="${escapeHtml(site.url)}"${icon}>${escapeHtml(site.name)}</A>${description}`;
    });
    return `${padding}<DT><H3>${escapeHtml(category.name)}</H3>\n${padding}<DL><p>\n${[...children, ...links].join("\n")}\n${padding}</DL><p>`;
  };
  const exportTitle = curated ? "星图链站长精选" : "星图链书签";
  const content = `<!DOCTYPE NETSCAPE-Bookmark-file-1>
<META HTTP-EQUIV="Content-Type" CONTENT="text/html; charset=UTF-8">
<TITLE>${exportTitle}</TITLE>
<H1>${curated ? "星图链站长精选" : "星图链 · 收藏全网，点亮星图"}</H1>
<DL><p>
${(byParent[0] || []).map(root => renderFolder(root)).join("\n")}
</DL><p>`;
  downloadTextFile(
    content,
    `${exportTitle}-${new Date().toISOString().slice(0, 10)}.html`,
    "text/html;charset=utf-8",
  );
  toast(`已导出 ${sites.length} 个${curated ? "精选" : "网址"}`);
}

function bindCategoryActions(scope = app) {
  scope.querySelectorAll("[data-edit-category]").forEach(button => button.onclick = () => {
    const template = button.dataset.template === "1";
    const collection = template ? state.defaultCategories : state.data.categories;
    const category = collection.find(item => item.id === Number(button.dataset.editCategory));
    showCategoryEditor(category, button.dataset.curated === "1", template);
  });
  scope.querySelectorAll("[data-delete-category]").forEach(button => button.onclick = () => {
    deleteCategory(
      Number(button.dataset.deleteCategory),
      button.dataset.curated === "1",
      button.dataset.template === "1",
    );
  });
  scope.querySelectorAll("[data-move-category]").forEach(button => button.onclick = () => {
    moveCategory(
      Number(button.dataset.moveCategory),
      button.dataset.direction,
      button.dataset.curated === "1",
      button.dataset.template === "1",
    );
  });
}

function categoryPath(id) {
  const map = Object.fromEntries(state.data.categories.map(category => [category.id, category]));
  const names = [];
  let current = map[id];
  while (current) { names.unshift(current.name); current = map[current.parent_id]; }
  return names.join(" / ");
}

function templateCategoryPath(id) {
  const map = Object.fromEntries(state.defaultCategories.map(category => [category.id, category]));
  const names = [];
  let current = map[id];
  while (current) { names.unshift(current.name); current = map[current.parent_id]; }
  return names.join(" / ");
}

function leafCategories(curated) {
  const categories = state.data.categories.filter(category => Boolean(category.is_curated) === curated);
  return categories.filter(category => categoryLevel(category.id, categories) === 3);
}

function showSiteEditor(site = null, curated = false, managedUserId = null, defaultCategoryId = null) {
  const isManaged = managedUserId !== null;
  const isCurated = !isManaged && (site ? Boolean(site.is_curated) : curated === true);
  const managedCategories = state.managedData.categories;
  const categories = isManaged
    ? managedCategories.filter(category => categoryLevel(category.id, managedCategories) === 3)
    : leafCategories(isCurated);
  const pathFor = isManaged ? managedCategoryPath : categoryPath;
  const scopeName = isManaged ? `${state.managedData.user?.username || "用户"}的` : (isCurated ? "精选" : "");
  modal(site ? `编辑${scopeName}网址` : `添加${scopeName}网址`, `<form id="site-form" class="form-stack">
    <label>网址<div class="url-row"><input name="url" type="url" required placeholder="https://example.com" value="${escapeHtml(site?.url || "")}"><button type="button" id="paste-url" class="secondary-btn">粘贴</button><button type="button" id="fetch-meta" class="secondary-btn">自动获取</button></div></label>
    <div id="fetch-status" class="fetch-status"></div>
    <label>网站名称<input name="name" required value="${escapeHtml(site?.name || "")}"></label>
    <label>图标地址<input name="icon_url" type="url" value="${escapeHtml(site?.icon_url || "")}"></label>
    <label>网站描述<textarea name="description" rows="3" placeholder="会直接显示在链接卡片中">${escapeHtml(site?.description || "")}</textarea></label>
    <label>显示顺序<input name="sort_order" type="number" min="0" value="${Number(site?.sort_order || 0)}"><small>数字越小越靠前，也可以在列表中使用上下箭头调整。</small></label>
    <label>第三级分类<select name="category_id" required>${categories.map(category => `<option value="${category.id}" ${String(site?.category_id || defaultCategoryId || "") === String(category.id) ? "selected" : ""}>${escapeHtml(pathFor(category.id))}</option>`).join("")}</select></label>
    <div id="duplicate-site-warning" class="duplicate-site-warning" hidden></div>
    ${!categories.length ? `<div class="notice">请先创建该范围内的第三级分类。</div>` : ""}
    <button class="primary-btn" id="site-submit" ${!categories.length ? "disabled" : ""}>${site ? "保存修改" : "添加到星图"}</button>
  </form>`);
  const form = document.querySelector("#site-form");
  const duplicateWarning = document.querySelector("#duplicate-site-warning");
  const resetDuplicateConfirmation = () => {
    delete form.dataset.duplicateConfirmation;
    duplicateWarning.hidden = true;
    duplicateWarning.innerHTML = "";
  };
  form.url.addEventListener("input", resetDuplicateConfirmation);
  form.category_id.addEventListener("change", resetDuplicateConfirmation);
  document.querySelector("#paste-url").onclick = async () => {
    try { form.url.value = await navigator.clipboard.readText(); resetDuplicateConfirmation(); } catch { toast("浏览器未授予剪贴板权限", "error"); }
  };
  document.querySelector("#fetch-meta").onclick = async () => {
    if (!form.url.value) return toast("请先输入网址", "error");
    const status = document.querySelector("#fetch-status"); status.textContent = "正在读取网页信息…";
    try {
      const data = await api("/metadata", { method: "POST", body: JSON.stringify({ url: form.url.value }) });
      form.url.value = data.url; form.name.value = data.name; form.icon_url.value = data.icon_url; form.description.value = data.description; resetDuplicateConfirmation();
      status.textContent = data.partial ? "已填写基础信息，可继续修改。" : "已自动填写，可直接保存。";
    } catch (error) { status.textContent = error.message; }
  };
  form.onsubmit = async event => {
    event.preventDefault();
    const values = Object.fromEntries(new FormData(event.target));
    values.category_id = Number(values.category_id);
    values.sort_order = Number(values.sort_order || 0);
    const base = isManaged ? `/admin/users/${managedUserId}/sites` : (isCurated ? "/admin/curated/sites" : "/sites");
    const duplicateKey = `${normalizedClientUrl(values.url)}|${values.category_id}`;
    const submitButton = event.submitter;
    submitButton.disabled = true;
    try {
      if (!isCurated && form.dataset.duplicateConfirmation !== duplicateKey) {
        const duplicateBase = isManaged ? `/admin/users/${managedUserId}/sites/duplicates` : "/sites/duplicates";
        const result = await api(duplicateBase, {
          method: "POST",
          body: JSON.stringify({ url: values.url, exclude_id: site?.id || null }),
        });
        if (result.duplicates.length) {
          const targetPath = pathFor(values.category_id);
          duplicateWarning.hidden = false;
          duplicateWarning.innerHTML = `<div><strong>这个网址已经收藏在以下分类</strong><p>你仍然可以把它添加到“${escapeHtml(targetPath)}”。</p></div><ul>${result.duplicates.map(item => `<li><span>${escapeHtml(item.name)}</span><small>${escapeHtml(item.category_path)}</small></li>`).join("")}</ul><div class="duplicate-site-actions"><button type="button" id="cancel-duplicate-site">返回修改</button><button type="button" id="confirm-duplicate-site">仍然添加到选定分类</button></div>`;
          duplicateWarning.scrollIntoView({ behavior: "smooth", block: "nearest" });
          duplicateWarning.querySelector("#cancel-duplicate-site").onclick = () => {
            resetDuplicateConfirmation();
            form.url.focus();
          };
          duplicateWarning.querySelector("#confirm-duplicate-site").onclick = () => {
            form.dataset.duplicateConfirmation = duplicateKey;
            form.requestSubmit(submitButton);
          };
          submitButton.disabled = false;
          return;
        }
      }
      values.allow_duplicate = form.dataset.duplicateConfirmation === duplicateKey;
      await api(site ? `${base}/${site.id}` : base, { method: site ? "PUT" : "POST", body: JSON.stringify(values) });
      if (isManaged) {
        await refreshManagedUserData(); closeModal(); renderManagedUserWorkspace();
      } else {
        await loadData(); closeModal(); renderWorkspace();
      }
      toast(site ? "网址已更新" : "网址已添加");
    } catch (error) {
      toast(error.message, "error");
      submitButton.disabled = false;
    }
  };
}

function showCategoryEditor(category = null, curated = false, template = false) {
  const source = template
    ? state.defaultCategories
    : state.data.categories.filter(item => Boolean(item.is_curated) === curated);
  const isRoot = category && category.parent_id == null;
  const categories = source.filter(item =>
    item.id !== category?.id && categoryLevel(item.id, source) < 3
  );
  const editorTitle = category
    ? `编辑${template ? "默认" : curated ? "精选" : ""}分类 · ${category.name}`
    : `添加${template ? "默认" : curated ? "精选" : ""}分类`;
  modal(editorTitle, `<form id="category-form" class="form-stack"><label>分类名称<input name="name" required value="${escapeHtml(category?.name || "")}"></label>
    ${isRoot ? `<div class="notice"><strong>一级分类固定</strong><span>可以修改名称，但不能移动或删除。</span></div>` : `<label>上级分类<select name="parent_id" required><option value="">请选择一级或二级分类</option>${categories.map(item => `<option value="${item.id}" ${String(category?.parent_id || "") === String(item.id) ? "selected" : ""}>${escapeHtml(template ? templateCategoryPath(item.id) : categoryPath(item.id))}</option>`).join("")}</select></label>`}
    <button class="primary-btn">${category ? "保存修改" : "添加分类"}</button></form>`);
  document.querySelector("#category-form").onsubmit = async event => {
    event.preventDefault();
    const values = Object.fromEntries(new FormData(event.target));
    values.parent_id = isRoot ? null : (values.parent_id ? Number(values.parent_id) : null);
    const base = template ? "/admin/default-categories" : (curated ? "/admin/curated/categories" : "/categories");
    try {
      await api(category ? `${base}/${category.id}` : base, { method: category ? "PUT" : "POST", body: JSON.stringify(values) });
      if (template) {
        await refreshDefaultCategories();
        closeModal();
        renderDefaultCategoryTree();
      } else {
        await loadData(); closeModal(); renderWorkspace();
      }
      toast("分类已保存");
    } catch (error) { toast(error.message, "error"); }
  };
}

function categoryLevel(id, categories) {
  const map = Object.fromEntries(categories.map(category => [category.id, category]));
  let level = 0;
  let current = map[id];
  while (current) { level += 1; current = map[current.parent_id]; }
  return level;
}

async function deleteSite(id, curated) {
  if (!confirm("确定删除这个网址？")) return;
  const base = curated ? "/admin/curated/sites" : "/sites";
  try { await api(`${base}/${id}`, { method: "DELETE" }); await loadData(); renderWorkspace(); toast("网址已删除"); }
  catch (error) { toast(error.message, "error"); }
}

async function deleteCategory(id, curated, template = false) {
  if (!confirm("删除分类会同时删除其子分类和网址，确定继续？")) return;
  const base = template ? "/admin/default-categories" : (curated ? "/admin/curated/categories" : "/categories");
  try {
    await api(`${base}/${id}`, { method: "DELETE" });
    if (template) { await refreshDefaultCategories(); renderDefaultCategoryTree(); }
    else { await loadData(); renderWorkspace(); }
    toast("分类已删除");
  }
  catch (error) { toast(error.message, "error"); }
}

async function moveCategory(id, direction, curated, template = false) {
  try {
    const category = template
      ? state.defaultCategories.find(item => item.id === id)
      : state.data.categories.find(item => item.id === id);
    const isCurated = template ? false : Boolean(category?.is_curated);
    const endpoint = template
      ? `/admin/default-categories/${id}/move`
      : (isCurated || curated)
        ? `/admin/curated/categories/${id}/move`
        : `/categories/${id}/move`;
    await api(endpoint, { method: "PUT", body: JSON.stringify({ direction }) });
    if (template) { await refreshDefaultCategories(); renderDefaultCategoryTree(); }
    else { await loadData(); renderWorkspace(); }
    toast("分类顺序已更新");
  } catch (error) {
    toast(error.message, "error");
  }
}

async function refreshDefaultCategories() {
  state.defaultCategories = await api("/admin/default-categories");
}

async function loadDefaultCategories() {
  try {
    await refreshDefaultCategories();
    renderDefaultCategoryTree();
  } catch (error) {
    document.querySelector("#default-category-tree").innerHTML = `<div class="empty-state">${escapeHtml(error.message)}</div>`;
  }
}

function renderDefaultCategoryTree() {
  const container = document.querySelector("#default-category-tree");
  if (!container) return;
  const { byParent } = categoryTreeFor(state.defaultCategories);
  const roots = byParent[0] || [];
  container.className = "category-tree";
  container.innerHTML = roots.map((root, index) =>
    categoryBranch(root, byParent, false, 1, index, roots.length, true)
  ).join("") || `<div class="empty-state">暂无默认分类</div>`;
  bindCategoryActions(container);
}

async function moveSite(id, direction, curated) {
  const current = state.data.sites.find(site => site.id === id && Boolean(site.is_curated) === curated);
  if (!current) return;
  const sites = state.data.sites.filter(site =>
    Boolean(site.is_curated) === curated && site.category_id === current.category_id
  );
  const index = sites.findIndex(site => site.id === id);
  const target = direction === "up" ? index - 1 : index + 1;
  if (target < 0 || target >= sites.length) return;
  [sites[index], sites[target]] = [sites[target], sites[index]];
  await api(curated ? "/admin/curated/site-order" : "/site-order", { method: "PUT", body: JSON.stringify({ ids: sites.map(site => site.id) }) });
  await loadData(); renderWorkspace();
}

function managedCategoryPath(id) {
  const map = Object.fromEntries(state.managedData.categories.map(category => [category.id, category]));
  const names = [];
  let current = map[id];
  while (current) { names.unshift(current.name); current = map[current.parent_id]; }
  return names.join(" / ");
}

async function refreshManagedUserData() {
  state.managedData = await api(`/admin/users/${state.managedUserId}/navigation`);
}

async function loadManagedUserWorkspace() {
  const container = document.querySelector("#managed-user-workspace");
  if (!container) return;
  try {
    const overview = await api("/admin/overview");
    state.managedUsers = overview.users.filter(user => !user.is_admin);
    if (!state.managedUsers.some(user => user.id === Number(state.managedUserId))) {
      state.managedUserId = state.managedUsers[0]?.id || null;
    }
    if (state.managedUserId) await refreshManagedUserData();
    renderManagedUserWorkspace();
  } catch (error) {
    container.innerHTML = `<div class="empty-state">${escapeHtml(error.message)}</div>`;
  }
}

function renderManagedUserWorkspace() {
  const container = document.querySelector("#managed-user-workspace");
  if (!container) return;
  if (!state.managedUsers.length) {
    container.innerHTML = `<div class="empty-state"><span>✧</span><h3>暂无可管理的普通用户</h3></div>`;
    return;
  }
  const user = state.managedData.user;
  container.innerHTML = `<section class="managed-user-bar">
    <label>选择用户<select id="managed-user-select">${state.managedUsers.map(item =>
      `<option value="${item.id}" ${item.id === Number(state.managedUserId) ? "selected" : ""}>${escapeHtml(item.username)} · ${item.site_count} 个网址</option>`
    ).join("")}</select></label>
    <div><strong>${escapeHtml(user?.username || "")}</strong><span>${escapeHtml(user?.email || user?.phone || "未绑定找回方式")}</span></div>
    <nav class="managed-mode-tabs"><button class="${state.managedMode === "categories" ? "active" : ""}" data-managed-mode="categories">分类</button><button class="${state.managedMode === "sites" ? "active" : ""}" data-managed-mode="sites">网址</button></nav>
  </section>
  <div id="managed-user-content">${state.managedMode === "categories" ? managedCategoriesContent() : managedSitesContent()}</div>`;
  bindManagedUserActions();
}

function managedCategoriesContent() {
  const { byParent } = categoryTreeFor(state.managedData.categories);
  const roots = byParent[0] || [];
  return `<div class="subpage-head"><div><h2>${escapeHtml(state.managedData.user?.username || "")}的分类</h2><p>可维护二、三级分类，也可重命名“我的星图”。</p></div><button class="primary-small" id="add-managed-category">＋ 添加分类</button></div>
    <div class="category-tree">${roots.map(root => managedCategoryBranch(root, byParent, 1, 0, 1)).join("")}</div>`;
}

function managedCategoryBranch(category, byParent, level, index, siblingCount) {
  const children = byParent[category.id] || [];
  return `<section class="category-branch level-${level}"><header><div class="level-badge">L${level}</div><div><strong>${escapeHtml(category.name)}</strong><small>${escapeHtml(managedCategoryPath(category.id))}</small></div><div class="row-actions">
    <button data-managed-move-category="${category.id}" data-direction="up" ${index === 0 ? "disabled" : ""}>↑</button>
    <button data-managed-move-category="${category.id}" data-direction="down" ${index === siblingCount - 1 ? "disabled" : ""}>↓</button>
    <button data-managed-edit-category="${category.id}">✎ 编辑</button>
    ${level === 1 ? "" : `<button data-managed-delete-category="${category.id}" class="danger">删除</button>`}
  </div></header>${children.map((child, childIndex) => managedCategoryBranch(child, byParent, level + 1, childIndex, children.length)).join("")}</section>`;
}

function managedSitesContent() {
  const categories = state.managedData.categories;
  const leaves = categories.filter(category => categoryLevel(category.id, categories) === 3);
  const groups = leaves.map(category => ({
    category,
    sites: state.managedData.sites.filter(site => site.category_id === category.id),
  })).filter(group => group.sites.length);
  return `<div class="subpage-head"><div><h2>${escapeHtml(state.managedData.user?.username || "")}的网址</h2><p>管理员添加或修改后，用户登录即可看到。</p></div><button class="primary-small" id="add-managed-site">＋ 添加网址</button></div>
    <div class="manager-groups">${groups.map(group => `<section class="manager-group"><header><div><h2>${escapeHtml(group.category.name)}</h2><p>${escapeHtml(managedCategoryPath(group.category.id))}</p></div><span>${group.sites.length}</span></header><div class="manage-list">${group.sites.map((site, index) => manageSiteRow(site, index, group.sites.length, false)).join("")}</div></section>`).join("") || `<div class="empty-state"><span>✧</span><h3>该用户还没有网址</h3></div>`}</div>`;
}

function bindManagedUserActions() {
  document.querySelector("#managed-user-select")?.addEventListener("change", async event => {
    state.managedUserId = Number(event.target.value);
    await refreshManagedUserData();
    renderManagedUserWorkspace();
  });
  document.querySelectorAll("[data-managed-mode]").forEach(button => button.onclick = () => {
    state.managedMode = button.dataset.managedMode;
    renderManagedUserWorkspace();
  });
  document.querySelector("#add-managed-category")?.addEventListener("click", () => showManagedCategoryEditor());
  document.querySelector("#add-managed-site")?.addEventListener("click", () => showSiteEditor(null, false, state.managedUserId));
  document.querySelectorAll("[data-managed-edit-category]").forEach(button => button.onclick = () => {
    showManagedCategoryEditor(state.managedData.categories.find(item => item.id === Number(button.dataset.managedEditCategory)));
  });
  document.querySelectorAll("[data-managed-delete-category]").forEach(button => button.onclick = () => deleteManagedCategory(Number(button.dataset.managedDeleteCategory)));
  document.querySelectorAll("[data-managed-move-category]").forEach(button => button.onclick = () => moveManagedCategory(Number(button.dataset.managedMoveCategory), button.dataset.direction));
  document.querySelectorAll("#managed-user-content [data-edit-site]").forEach(button => button.onclick = () => {
    showSiteEditor(state.managedData.sites.find(item => item.id === Number(button.dataset.editSite)), false, state.managedUserId);
  });
  document.querySelectorAll("#managed-user-content [data-delete-site]").forEach(button => button.onclick = () => deleteManagedSite(Number(button.dataset.deleteSite)));
  document.querySelectorAll("#managed-user-content [data-move]").forEach(button => button.onclick = () => moveManagedSite(Number(button.closest("[data-manage-site]").dataset.manageSite), button.dataset.move));
}

function showManagedCategoryEditor(category = null) {
  const source = state.managedData.categories;
  const isRoot = category && category.parent_id == null;
  const parents = source.filter(item => item.id !== category?.id && categoryLevel(item.id, source) < 3);
  modal(category ? `编辑用户分类 · ${category.name}` : "添加用户分类", `<form id="managed-category-form" class="form-stack">
    <label>分类名称<input name="name" required value="${escapeHtml(category?.name || "")}"></label>
    ${isRoot ? `<div class="notice">一级分类只能重命名，不能移动或删除。</div>` : `<label>上级分类<select name="parent_id" required><option value="">请选择一级或二级分类</option>${parents.map(parent => `<option value="${parent.id}" ${String(category?.parent_id || "") === String(parent.id) ? "selected" : ""}>${escapeHtml(managedCategoryPath(parent.id))}</option>`).join("")}</select></label>`}
    <button class="primary-btn">${category ? "保存修改" : "添加分类"}</button>
  </form>`);
  document.querySelector("#managed-category-form").onsubmit = async event => {
    event.preventDefault();
    const values = Object.fromEntries(new FormData(event.target));
    values.parent_id = isRoot ? null : Number(values.parent_id);
    const base = `/admin/users/${state.managedUserId}/categories`;
    try {
      await api(category ? `${base}/${category.id}` : base, { method: category ? "PUT" : "POST", body: JSON.stringify(values) });
      await refreshManagedUserData(); closeModal(); renderManagedUserWorkspace(); toast("用户分类已保存");
    } catch (error) { toast(error.message, "error"); }
  };
}

async function deleteManagedCategory(id) {
  if (!confirm("删除后其子分类和网址也会删除，确定继续？")) return;
  try {
    await api(`/admin/users/${state.managedUserId}/categories/${id}`, { method: "DELETE" });
    await refreshManagedUserData(); renderManagedUserWorkspace(); toast("用户分类已删除");
  } catch (error) { toast(error.message, "error"); }
}

async function moveManagedCategory(id, direction) {
  try {
    await api(`/admin/users/${state.managedUserId}/categories/${id}/move`, { method: "PUT", body: JSON.stringify({ direction }) });
    await refreshManagedUserData(); renderManagedUserWorkspace(); toast("用户分类顺序已更新");
  } catch (error) { toast(error.message, "error"); }
}

async function deleteManagedSite(id) {
  if (!confirm("确定删除这个用户网址？")) return;
  try {
    await api(`/admin/users/${state.managedUserId}/sites/${id}`, { method: "DELETE" });
    await refreshManagedUserData(); renderManagedUserWorkspace(); toast("用户网址已删除");
  } catch (error) { toast(error.message, "error"); }
}

async function moveManagedSite(id, direction) {
  const current = state.managedData.sites.find(site => site.id === id);
  const sites = state.managedData.sites.filter(site => site.category_id === current?.category_id);
  const index = sites.findIndex(site => site.id === id);
  const target = direction === "up" ? index - 1 : index + 1;
  if (target < 0 || target >= sites.length) return;
  [sites[index], sites[target]] = [sites[target], sites[index]];
  try {
    await api(`/admin/users/${state.managedUserId}/site-order`, { method: "PUT", body: JSON.stringify({ ids: sites.map(site => site.id) }) });
    await refreshManagedUserData(); renderManagedUserWorkspace(); toast("用户网址顺序已更新");
  } catch (error) { toast(error.message, "error"); }
}

async function loadAccessControl() {
  const container = document.querySelector("#access-control-workspace");
  if (!container) return;
  try {
    state.accessControl = await api("/admin/access-control");
    renderAccessControl();
  } catch (error) {
    container.innerHTML = `<div class="empty-state">${escapeHtml(error.message)}</div>`;
  }
}

function renderAccessControl() {
  const container = document.querySelector("#access-control-workspace");
  if (!container || !state.accessControl) return;
  const access = state.accessControl;
  const users = Object.fromEntries(access.users.map(user => [user.id, user]));
  const categories = Object.fromEntries(access.secondary_categories.map(category => [category.id, category]));
  container.innerHTML = `<section class="access-global">
    <div><p class="eyebrow">GLOBAL FEATURE</p><h2>星图导入与导出</h2><p>两个权限独立管理，默认关闭。全站未开启时，仍可通过用户组分别授权。</p></div>
    <form id="global-feature-form"><label class="switch-line"><input type="checkbox" name="bookmark_import_enabled" ${access.bookmark_import_enabled ? "checked" : ""}><span>对全部用户开放导入</span></label><label class="switch-line"><input type="checkbox" name="bookmark_export_enabled" ${access.bookmark_export_enabled ? "checked" : ""}><span>对全部用户开放导出</span></label><button class="secondary-btn">保存开关</button></form>
  </section>
  <div class="access-groups">${access.groups.map(group => {
    const memberNames = group.user_ids.map(id => users[id]?.username).filter(Boolean);
    const categoryNames = group.category_ids.map(id => categories[id]?.name).filter(Boolean);
    return `<article class="access-group-card"><header><div><h2>${escapeHtml(group.name)}</h2><p>${escapeHtml(group.description || "未填写说明")}</p></div><div class="row-actions"><button data-edit-group="${group.id}">编辑</button><button data-delete-group="${group.id}" class="danger">删除</button></div></header>
      <div class="access-group-details"><div><strong>功能权限</strong><p>${group.bookmark_import ? `<span class="access-chip">导入星图</span>` : ""}${group.bookmark_export ? `<span class="access-chip">导出星图</span>` : ""}${!group.bookmark_import && !group.bookmark_export ? "无额外功能" : ""}</p></div><div><strong>成员 · ${memberNames.length}</strong><p>${memberNames.length ? memberNames.map(escapeHtml).join("、") : "暂无成员"}</p></div><div><strong>额外二级分类 · ${categoryNames.length}</strong><p>${categoryNames.length ? categoryNames.map(name => `<span class="access-chip">${escapeHtml(name)}</span>`).join(" ") : "无额外分类"}</p></div></div>
    </article>`;
  }).join("") || `<div class="empty-state"><span>⊕</span><h3>还没有用户组</h3><p>新建用户组后即可按组增加权限。</p></div>`}</div>`;
  container.querySelector("#global-feature-form").onsubmit = async event => {
    event.preventDefault();
    const importEnabled = event.currentTarget.elements.bookmark_import_enabled.checked;
    const exportEnabled = event.currentTarget.elements.bookmark_export_enabled.checked;
    try {
      await api("/admin/access-control/features", {
        method: "PUT", body: JSON.stringify({
          bookmark_import_enabled: importEnabled,
          bookmark_export_enabled: exportEnabled,
        }),
      });
      state.me = await api("/me");
      await loadAccessControl();
      toast("导入和导出全站开关已保存");
    } catch (error) { toast(error.message, "error"); }
  };
  container.querySelectorAll("[data-edit-group]").forEach(button => {
    button.onclick = () => showUserGroupEditor(access.groups.find(group => group.id === Number(button.dataset.editGroup)));
  });
  container.querySelectorAll("[data-delete-group]").forEach(button => {
    button.onclick = async () => {
      if (!confirm("删除用户组后，其功能和二级分类授权会立即失效，确定继续？")) return;
      try {
        await api(`/admin/groups/${button.dataset.deleteGroup}`, { method: "DELETE" });
        state.me = await api("/me");
        await loadAccessControl();
        toast("用户组已删除");
      } catch (error) { toast(error.message, "error"); }
    };
  });
}

function showUserGroupEditor(group = null) {
  const access = state.accessControl;
  if (!access) return;
  const selectedUsers = new Set(group?.user_ids || []);
  const selectedCategories = new Set(group?.category_ids || []);
  modal(group ? `编辑用户组 · ${group.name}` : "新建用户组", `<form id="user-group-form" class="form-stack">
    <label>用户组名称<input name="name" required maxlength="50" value="${escapeHtml(group?.name || "")}" placeholder="例如：高级用户"></label>
    <label>说明<textarea name="description" rows="2" maxlength="200" placeholder="说明这个用户组的用途">${escapeHtml(group?.description || "")}</textarea></label>
    <fieldset class="access-fieldset"><legend>功能权限</legend><div class="access-option-grid"><label class="check-option"><input type="checkbox" name="bookmark_import" ${group?.bookmark_import ? "checked" : ""}><span><strong>导入星图</strong><small>可导入完整二、三级分类与网址，也可使用旧版书签导入。</small></span></label><label class="check-option"><input type="checkbox" name="bookmark_export" ${group?.bookmark_export ? "checked" : ""}><span><strong>导出星图</strong><small>可导出星图链 JSON 完整备份或浏览器书签 HTML。</small></span></label></div></fieldset>
    <fieldset class="access-fieldset"><legend>用户组成员</legend><div class="access-option-grid">${access.users.map(user => `<label class="check-option"><input type="checkbox" name="user_ids" value="${user.id}" ${selectedUsers.has(user.id) ? "checked" : ""}><span><strong>${escapeHtml(user.username)}</strong><small>${escapeHtml(user.email || user.phone || (user.is_admin ? "管理员" : "普通用户"))}</small></span></label>`).join("") || "暂无用户"}</div></fieldset>
    <fieldset class="access-fieldset"><legend>额外显示的站长精选二级分类</legend><div class="notice"><strong>绑定后，该二级分类变为用户组专属</strong><span>访客和未授权用户将不再看到它及其下属网址；属于任一已授权用户组的成员仍可查看。</span></div><div class="access-option-grid">${access.secondary_categories.map(category => `<label class="check-option"><input type="checkbox" name="category_ids" value="${category.id}" ${selectedCategories.has(category.id) ? "checked" : ""}><span><strong>${escapeHtml(category.name)}</strong><small>${escapeHtml(categoryPath(category.id))}</small></span></label>`).join("") || "暂无可授权的二级分类"}</div></fieldset>
    <button class="primary-btn">${group ? "保存用户组" : "创建用户组"} <span>→</span></button>
  </form>`, "wide-modal");
  document.querySelector("#user-group-form").onsubmit = async event => {
    event.preventDefault();
    const form = event.currentTarget;
    const payload = {
      name: form.elements.name.value,
      description: form.elements.description.value,
      bookmark_import: form.elements.bookmark_import.checked,
      bookmark_export: form.elements.bookmark_export.checked,
      user_ids: Array.from(form.querySelectorAll('[name="user_ids"]:checked')).map(input => Number(input.value)),
      category_ids: Array.from(form.querySelectorAll('[name="category_ids"]:checked')).map(input => Number(input.value)),
    };
    event.submitter.disabled = true;
    try {
      await api(group ? `/admin/groups/${group.id}` : "/admin/groups", {
        method: group ? "PUT" : "POST", body: JSON.stringify(payload),
      });
      state.me = await api("/me");
      closeModal();
      await loadAccessControl();
      toast(group ? "用户组已更新" : "用户组已创建");
    } catch (error) {
      toast(error.message, "error");
      event.submitter.disabled = false;
    }
  };
}

async function loadAdminOverview() {
  const container = document.querySelector("#admin-overview");
  try {
    const data = await api("/admin/overview");
    const clicks = data.users.reduce((total, user) => total + user.click_count, 0);
    container.innerHTML = `<div class="admin-stats"><div><span>注册用户</span><strong>${data.users.length}</strong></div><div><span>私人网址</span><strong>${data.sites.length}</strong></div><div><span>累计点击</span><strong>${clicks}</strong></div><div><span>活跃终端</span><strong>${data.sessions.length}</strong></div></div>
      <section class="data-section"><h2>用户账号</h2>${table(["用户", "找回方式", "网址", "点击", "终端", "最近登录", "操作"], data.users.map(user => [escapeHtml(user.username), escapeHtml(user.email || user.phone || "—"), user.site_count, user.click_count, user.session_count, formatDate(user.last_login_at), `<button class="table-btn" data-reset-user="${user.id}">重置密码</button>`]))}</section>
      <section class="data-section"><h2>登录终端</h2>${table(["用户", "设备", "浏览器", "IP", "访问次数", "首次登录", "最后活跃"], data.sessions.map(session => [escapeHtml(session.username), escapeHtml(session.device), escapeHtml(session.browser), escapeHtml(session.ip), session.access_count, formatDate(session.created_at), formatDate(session.last_seen_at)]))}</section>`;
    container.querySelectorAll("[data-reset-user]").forEach(button => button.onclick = async () => {
      if (!confirm("将该账号密码重置为 1234，并退出其所有终端？")) return;
      await api(`/admin/users/${button.dataset.resetUser}/reset-password`, { method: "POST" }); toast("密码已重置为 1234");
    });
  } catch (error) { container.innerHTML = `<div class="empty-state">${escapeHtml(error.message)}</div>`; }
}

function table(headers, rows) {
  return `<div class="table-wrap"><table><thead><tr>${headers.map(header => `<th>${header}</th>`).join("")}</tr></thead><tbody>${rows.map(row => `<tr>${row.map(cell => `<td>${cell ?? "—"}</td>`).join("")}</tr>`).join("")}</tbody></table></div>`;
}

function formatDate(value) {
  return value ? new Date(value).toLocaleString("zh-CN", { hour12: false }) : "—";
}

function footer() {
  return `<footer class="site-footer">
    <div class="footer-brand"><img class="brand-logo" src="${brandLogoSrc()}" alt=""><div><strong>星图链</strong><span>收藏全网，点亮星图</span></div></div>
    <p>以三级分类组织网址收藏，公开浏览站长精选，登录后建立清晰、快捷、属于你的个人网址导航。</p>
    <div class="footer-meta"><span>© 2026 星图链</span><button id="footer-terms" type="button">服务条款</button><a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">粤ICP备2025475993号-1</a></div>
  </footer>`;
}

function modal(title, content, size = "") {
  closeModal();
  const root = document.createElement("div");
  root.id = "modal-root";
  root.innerHTML = `<div class="modal-backdrop"></div><section class="modal ${size}" role="dialog" aria-modal="true" aria-labelledby="modal-title"><header><h2 id="modal-title">${escapeHtml(title)}</h2><button id="modal-close" aria-label="关闭">×</button></header><div class="modal-body">${content}</div></section>`;
  document.body.appendChild(root);
  root.querySelector(".modal-backdrop").onclick = closeModal;
  root.querySelector("#modal-close").onclick = closeModal;
  document.onkeydown = event => { if (event.key === "Escape") closeModal(); };
}

function closeModal() {
  document.querySelector("#modal-root")?.remove();
  document.onkeydown = null;
}

boot();
